import { HttpParams } from '@angular/common/http';
import { TruncatePipe } from 'src/app/pipe/TruncatePipe.pipe';
import { ApplicationRef, ChangeDetectorRef, Component, ComponentFactoryResolver, ComponentRef, EmbeddedViewRef, EventEmitter, Injector, Input, OnChanges, OnDestroy, OnInit, Output, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { CommonModule, TitleCasePipe } from '@angular/common';
import { ReactiveFormsModule, FormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { NgbModalOptions, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { finalize, Observable } from 'rxjs';
import { AppSettings } from 'src/app/services/AppSettings';
import { CandidateService } from 'src/app/services/CandidateService';
import { FormValidation } from 'src/app/services/FormValidation';
import { GigsumoConstants } from 'src/app/services/GigsumoConstants';
import { ApiService } from 'src/app/services/api.service';
import { APPLICANT_STATUS, GigsumoService } from 'src/app/services/gigsumoService';
import { JobService } from 'src/app/services/job.service';
import { JobModel } from 'src/app/services/jobModel';
import { SearchData } from 'src/app/services/searchData';
import { SlidePanelService } from 'src/app/services/slide-panel.service';
import { UtilService } from 'src/app/services/util.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { SocketService } from '../../../services/socket.service';
import { PricePlanService } from '../../Price-subscritions/priceplanService';
import { CreditModelComponent } from '../../credit/credit-model/credit-model.component';
import { CommonSkeletonComponent } from '../../../skeleton/common-skeleton/common-skeleton.component';
import { HandlingValue } from '../../../directives/HandlingValue';
import { MessageWidgetComponent } from '../../../widget/message-widget/message-widget.component';
import { TimezoneDatePipe } from '../../../timezone-date.pipe';
import { FlagComponent } from '../../flag/flag.component';
import { ConnectionTemplateComponent } from '../../../templates/connection-template/connection-template.component';
import { CandidateDocumentsComponent } from '../../job-module/candidate-documents/candidate-documents.component';
import { MatchPercentageDetailsComponent } from '../../match-percentage-details/match-percentage-details.component';
import { promise } from 'protractor';
import { CustomValidator } from '../../Helper/custom-validator';
import { ContractCandidateService } from 'src/app/services/contract-candidate.service';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';
import { CompactCountPipe } from '../../../pipe/compact-count.pipe';
import { isEyeIconMenu } from 'src/app/services/eye-icon-menu';

// import { NewJobComponent } from '../../../page/homepage/layout-jobs/new-job/new-job.component';

@Component({
  selector: "app-candidate-card",
  standalone: true,
  imports: [
    CompactCountPipe,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    BsDropdownModule,
    NgbDropdownModule,
CommonSkeletonComponent,
    HandlingValue,
    TruncatePipe,
    MessageWidgetComponent,
    TimezoneDatePipe,
    FlagComponent,
    ConnectionTemplateComponent,
    CandidateDocumentsComponent,
    MatchPercentageDetailsComponent,
    // NewJobComponent,
    TitleCasePipe
  ,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: "./candidate-card.component.html",
  styleUrls: ["./candidate-card.component.scss"],
})
export class CandidateCardComponent extends FormValidation implements OnInit, OnChanges, OnDestroy {

  /** Report Candidate hidden app-wide until the reporting flow is built.
   *  See the note on JobCardComponent.reportEnabled; grep "reportEnabled". */
  reportEnabled = false;
  @Input() viewSize: any;
  @Input() passValues: any;
  @Input() showCheckBox: any;
  @Input() removeSelected: any;
  @Input() removeTag: any;
  @Input() From: "SUGGESTED_CANDIDATES" | "FEATURED_CANDIDATE" | "CANDIDATES_FROM_CONNECTION";
  @Input() candidatesFoundStatus: any;
  @Input() isRoutingDisabled: boolean = false;
  // Enables the large card's non-owner three-dot menu (Report / View) on pages
  // that have no job context, where jobStatus is "" and the menu would otherwise
  // render disabled: Marketplace Candidates, Featured Candidates, Activity Feed ->
  // Active Interactions -> Resume Downloaded.
  @Input() actionMenuEnabled: boolean = false;
  @Input() userId: any;
  appSettings: AppSettings;
  userType: any;
  removetagValueget: any;
  flag: boolean = true;
  filtersApplied: boolean = false;
  @Input() data: any;
  url = AppSettings.photoUrl;
  jobfilter: boolean = false;
  @Output() selectedCandidate: EventEmitter<any> = new EventEmitter();
  @Output() removeSeletedUser: EventEmitter<any> = new EventEmitter();
  dataget;
  checkcount: number = 0;
  checkedList: any = [];
  FormData: any;
  creditform: UntypedFormGroup;
  clickItemActive: any;
  showmodel = false;
  GigsumoConstant = GigsumoConstants;
  @Output() suggjob: EventEmitter<any> = new EventEmitter();
  bsModalRef: BsModalRef;
  @Input() candidateval: any;
  @Input() resumerequsetuser: any;
  @Input() selectedcandiCount: any;
  @Input() disabledCheckbox: boolean;
  @Input() showStatus: any;
  @Input() inviteapplyhide: any;
  @Input() datas: any;
  @Input() appliedJobDetails: JobModel;
  @Input() jobDetails: JobModel; // Alias for appliedJobDetails used in some templates
  @Input() filterApplicantData: any;
  @Input() allowedJobCandidateCounts: number = 0;
  @Input() isDowngraded: boolean = false;
  @Input() showTimeline: any;
  @Input() aiMatchHide: boolean = false; // For contract-row view to hide AI Match column
  @Input() contractActionLabel: string = 'Initiate Contract';
  /** 'supplier' = I am customer viewing supplier candidates (demand/verify mode)
   *  'customer' = I am supplier viewing customer candidates (upload mode) */
  @Input() contractContext: 'supplier' | 'customer' | 'my-company' = 'supplier';
  /** From validate-initiate API — passed to work order wizard for pre-condition info */
  @Input() canInitiateContract: boolean = false;
  /** contractTrackingStatus-based button states */
  @Input() initiateContractEnabled: boolean = false;
  @Input() initiateContractCompleted: boolean = false;
  @Input() signContractEnabled: boolean = false;
  @Input() signContractCompleted: boolean = false;
  @Input() initiateWOEnabled: boolean = false;
  @Input() initiateWOCompleted: boolean = false;

  /**
   * Locked 2026-06-10 — 3-state icon color based on raw contractTrackingStatus.
   * Returns one of: 'ctrv3-action-icon-pending' (RED), 'ctrv3-action-icon-active'
   * (ORANGE), 'ctrv3-action-icon-done' (GREEN).
   *
   * Mental model: until THIS specific action's work has begun, it's RED. While the
   * action is ongoing, ORANGE. Once done, GREEN. The `enabled` Input flags don't
   * map cleanly because they conflate "actionable now" with "in progress" —
   * Initiate Contract is enabled at NOT_INITIATED (user can click) but it hasn't
   * STARTED yet, so the icon must show RED until clicked, not ORANGE.
   *
   * Status pipeline reminder:
   *   NOT_INITIATED → CONTRACT_INITIATED → CONTRACT_IN_PROGRESS → SUPPLIER_SIGNED →
   *   CUSTOMER_SIGNED → CONTRACT_COMPLETED → WORKORDER_INITIATED → WORKORDER_SIGNED
   */
  getContractActionColorClass(button: 'initiate' | 'sign' | 'wo'): string {
    const status = (this.candidateval?.contractData?.contractTrackingStatus || 'NOT_INITIATED').toUpperCase();

    if (button === 'initiate') {
      // One-shot action: pending until contract is initiated, then done. No "in
      // progress" state — the moment it flips off NOT_INITIATED it's done.
      return status === 'NOT_INITIATED' ? 'ctrv3-action-icon-pending' : 'ctrv3-action-icon-done';
    }

    if (button === 'sign') {
      // Signing can only start once the contract is initiated. ORANGE covers the
      // multi-step signing phase (initiated → in progress → one side signed).
      if (status === 'NOT_INITIATED') return 'ctrv3-action-icon-pending';
      if (['CONTRACT_INITIATED', 'CONTRACT_IN_PROGRESS', 'SUPPLIER_SIGNED'].includes(status)) {
        return 'ctrv3-action-icon-active';
      }
      // CONTRACT_COMPLETED / CUSTOMER_SIGNED / WORKORDER_INITIATED / WORKORDER_SIGNED.
      return 'ctrv3-action-icon-done';
    }

    if (button === 'wo') {
      // WO becomes reachable at CONTRACT_COMPLETED. ORANGE while it's the active
      // step (CONTRACT_COMPLETED ready-to-initiate, or WORKORDER_INITIATED mid-flow).
      if (status === 'WORKORDER_SIGNED') return 'ctrv3-action-icon-done';
      if (['CONTRACT_COMPLETED', 'WORKORDER_INITIATED'].includes(status)) {
        return 'ctrv3-action-icon-active';
      }
      return 'ctrv3-action-icon-pending';
    }

    return 'ctrv3-action-icon-pending';
  }

  get documentPanelPageName(): string {
    // Role-correct mode per viewer (contractContext is set from
    // `supplierBusinessId === myBusinessId ? 'customer' : 'supplier'`, so the names are inverted):
    //   - contractContext === 'customer'  → viewer IS the supplier (candidate owner) → UPLOAD view ('job-card')
    //   - contractContext === 'supplier'  → viewer IS the customer (job owner) → DEMAND/VERIFY view ('candidate-card')
    // The customer demands (creating the DocumentConfiguration); the supplier then uploads against it.
    if (this.pageName === 'contract-candidates' && this.contractContext === 'customer') {
      return 'job-card';
    }
    return 'candidate-card';
  }
  JobModel;
  submited: boolean = false;
  Resurl = AppSettings.ServerUrl;
  jobId;
  jobTitle;
  jobPostedBehalfOf;
  postedByUserName;
  download = environment.serverUrl + "/download/";
  seletedChatItem;
  messageData: any;
  messagemodelflag: any;
  @Input() candidatesApplied: string;
  jobStatus: string = "";
  @Input() pageName: any;
  @Input() hideAiInsights = false;
  @Input() currentJobId: string; // For showing job-specific details in slider
  // When true, openCandidateInSlidePanel routes to the new V3 slider
  // (`<app-candidate-profile-slider>`). Default stays V2 so existing callers
  // (network/marketplace/etc.) keep their current behaviour.
  @Input() useV3Slider: boolean = false;
  // True only on the Talent Pool surface (set by customer-business-candidatelist).
  // Lets the slider tell Talent Center apart from Talent Pool — the
  // "own candidate" Connect/Chat hide + "You" label is Talent Center only.
  @Input() isTalentPool: boolean = false;
  public envName: any = environment.name;
  checkingApplyButton: boolean = false;
  connectionStatus: string;
  connectionRequestRef: BsModalRef;
  values: any;
  counterpartsDetails: any;
  candidateSupplyRef: BsModalRef;
  isWait: boolean = false;
  hasCurrentOrganization: boolean = false;
  skillsExpanded: boolean = false; // Track skill expansion state

  showDocumentSection: boolean = false;

  // RTR Payrate popup for OFFERED status
  rtrformgrp: UntypedFormGroup;
  rtrModalRef: BsModalRef;
  submitRTR: boolean = false;
  private pendingOfferedData: any = null;
  private pendingOfferedCandidate: any = null;
  private b2bData: any = null;

  @Output() statusUpdated = new EventEmitter<any>();
  @Output() initializeWorkOrder = new EventEmitter<any>();
  @Output() signContract = new EventEmitter<any>();
  @Output() releaseWorkOrder = new EventEmitter<any>();
  @Output() documentsClosed = new EventEmitter<void>();
  @Output() openEventLog = new EventEmitter<any>();

  // Dynamic component loading for NewJobComponent (circular dependency fix)
  @ViewChild('jobsupplytemplate', { static: false }) jobsupplytemplate: TemplateRef<any>;
  private newJobContainer: ViewContainerRef | null = null;
  private newJobComponentRef: ComponentRef<any> | null = null;

  constructor(
    private apiService: ApiService,
    private _socket: SocketService,
    private searchData: SearchData,
    private modalService: BsModalService,
    private router: Router,
    private util: UtilService,
    private a_route: ActivatedRoute,
    private formBuilder: UntypedFormBuilder,
    private planService: PricePlanService,
    private candidateService: CandidateService,
    private JobServicecolor: JobService,
    private pricePlanService: PricePlanService,
    public gigsumoService: GigsumoService,
    private slidePanelService: SlidePanelService,
    private injector: Injector,
    private cdr: ChangeDetectorRef,
    private contractCandidateService: ContractCandidateService
  ) {
    super();
    this.userId = localStorage.getItem("userId");
    if (this.a_route.snapshot.url[0] && this.a_route.snapshot.url[0].path) {
      this.checkingApplyButton = this.a_route.snapshot.url[0].path === "job-applicants";
    } else {
      this.checkingApplyButton = false;
    }
  }
  shouldShowStatusText(): boolean {
    // don't show status text for business candidate route
    // const isBusinessCandidateRoute = this.a_route.snapshot.url[0]?.path === 'business-jobs'; 
    // if(isBusinessCandidateRoute) {
    //   return false;  
    // } 

    return this.candidateval?.status === 'INACTIVE' ||
           this.candidateval?.status === 'BLOCKED' ||
           !this.candidateval?.availability;
  }

  getStatusText(): string {
    if (this.candidateval?.status === 'BLOCKED')  return 'Blocked';
    if (this.candidateval?.status === 'DRAFTED')  return 'Draft';
    return 'Unavailable';  
  }


  ngOnInit(): void {
    this.gigsumoService.loadMyBusinessId();
    this.checkCurrentOrganization();
    this.creditform = this.formBuilder.group({
      point: [
        null,
        Validators.compose([
          Validators.required,
          Validators.pattern(/^-?(0|[1-9]\d*)?$/),
        ]),
      ],
    });
    // Locked 2026-06-08 — two-row payrate model. submittedToRate + submittedRateType
    // are read-only and reflect the viewer's tier published ceiling from JobDetails.
    // tierPayRates[]. offerRate + offerRateType are what the recruiter offers this
    // candidate (persisted as targetRate + payType on ContractCandidate).
    this.rtrformgrp = this.formBuilder.group({
      submittedToRate: [{ value: null, disabled: true }],
      submittedRateType: [{ value: null, disabled: true }],
      offerRate: [null, Validators.compose([Validators.required, CustomValidator.validDecimal(), CustomValidator.checkWhiteSpace()])],
      offerRateType: [null, Validators.required],
      termsandcondition: [null, Validators.requiredTrue],
      country: [null]
    });
    this.userType = localStorage.getItem("userType");
    if (this.data != null) {
      this.flag = false;
    }


    this.jobStatus = this.appliedJobDetails && this.appliedJobDetails.status !== undefined
      ? this.appliedJobDetails.status
      : "";

    this.jobId = this.appliedJobDetails && this.appliedJobDetails.jobId;
    this.jobTitle = this.appliedJobDetails && this.appliedJobDetails.jobTitle;
    this.postedByUserName = this.appliedJobDetails && this.appliedJobDetails.postedByUserName;
    this.jobPostedBehalfOf = this.appliedJobDetails && this.appliedJobDetails.jobPostedBehalfOf;


    if (this.selectedcandiCount == undefined || this.selectedcandiCount == null) {
      this.selectedcandiCount = 1;
    }

    // Initialize timeline data for medium view
    if (this.viewSize === 'medium' && this.showTimeline == true) {
      setTimeout(() => {
        console.log('Timeline init - viewSize:', this.viewSize, 'candidateId:', this.candidateval?.candidateId, 'jobId:', this.appliedJobDetails?.jobId);
        this.loadTimelineData();
      }, 1000);
    }

    // Initialize showAllSkills for row-design view
    if (this.viewSize === 'row-design' && this.candidateval) {
      if (this.candidateval.showAllSkills === undefined) {
        this.candidateval.showAllSkills = false;
      }
    }

    if(this.pageName == 'job-applicants'){
      // this.getSavedRequiredDocuments();
    }

    if(this.pageName == 'contract-candidates'){
      this.getSavedRequiredDocuments();
    }

    if(this.showTimeline){
      this.prepareTimeline();
    }
  }

  triggerChange(candidateId: string) {

  }


  steps: string[] = [
  'Applied',
  'Shortlisted',
  'Interview',
  'Selected',
  'Offered',
  'Onboarded'
];

// Returns numeric step based on status string
getCandidateStep(status: string): number { 
  const idx = this.steps.findIndex(s => s.toLowerCase() === (status || '').toLowerCase());
  return idx >= 0 ? idx + 1 : 0; // 1-based
}

// Converts completedSteps into percentage for the green bar
getTimelineProgressPercent(completedSteps: number, totalSteps = 6): number {
  if (!completedSteps || totalSteps <= 1) return 0;
  return ((completedSteps - 1) / (totalSteps - 1)) * 100;
}

// Timeline API Integration Methods
timelineCache: Map<string, any> = new Map();

// Check if a timeline step is completed based on candidate status
isStepCompleted(stepStatus: string, candidate: any): boolean {
  if (!candidate) return false;
  
  const currentStatus = candidate.currentStatus || candidate.status || 'APPLIED';
  
  const statusHierarchy = [
    'APPLIED', 'SHORTLISTED', 'INTERVIEW SCHEDULED', 
    'SELECTED', 'OFFERED', 'ONBOARDED'
  ];
  
  const currentIndex = statusHierarchy.indexOf(currentStatus?.toUpperCase());
  const stepIndex = statusHierarchy.indexOf(stepStatus?.toUpperCase());
  
  return currentIndex > stepIndex && currentIndex >= 0;
}

getCurrentStep(candidate: any): string {
  if (!candidate) return 'APPLIED';
  
  const currentStatus = candidate.currentStatus || candidate.status || 'APPLIED';
  
  // Map similar statuses to timeline steps
  const statusMapping: { [key: string]: string } = {
    'APPLIED': 'APPLIED',
    'SHORTLISTED': 'SHORTLISTED', 
    'INTERVIEW SCHEDULED': 'INTERVIEW',
    'INTERVIEW': 'INTERVIEW',
    'SELECTED': 'SELECTED',
    'OFFERED': 'OFFERED',
    'ONBOARDED': 'ONBOARDED'
  };
  
  return statusMapping[currentStatus?.toUpperCase()] || 'APPLIED';
}

  // Some candidate sources (e.g. featured candidates) return a skill entry
  // as a single comma-joined string instead of one skill per array item.
  // Split those out so counting/"+N more" and each chip work per-skill.
  getFlattenedSkills(skills: any[]): string[] {
    if (!skills || !Array.isArray(skills)) return [];
    const flattened: string[] = [];
    skills.forEach(skill => {
      if (typeof skill === 'string' && skill.includes(',')) {
        flattened.push(...skill.split(',').map(s => s.trim()).filter(Boolean));
      } else if (skill) {
        flattened.push(skill);
      }
    });
    return flattened;
  }

  // Toggle skills visibility
  toggleSkills(item?: any): void {
    if (item) {
      // For row-design view and v2 large view
      if (item.showAllSkills !== undefined) {
        item.showAllSkills = !item.showAllSkills;
      } else {
        // Initialize skillsExpanded if not present
        if (item.skillsExpanded === undefined) {
          item.skillsExpanded = false;
        }
        item.skillsExpanded = !item.skillsExpanded;
      }
    } else {
      // For v2 large view (fallback) - toggle for current candidate
      if (this.candidateval) {
        if (this.candidateval.skillsExpanded === undefined) {
          this.candidateval.skillsExpanded = false;
        }
        this.candidateval.skillsExpanded = !this.candidateval.skillsExpanded;
      } else {
        this.skillsExpanded = !this.skillsExpanded;
      }
    }
  }

getTotalSkillsCount(candidate: any): number {
  if (!candidate) return 0;
  const primaryCount = candidate.primarySkills?.length || 0;
  const secondaryCount = candidate.secondarySkills?.length || 0;
  return primaryCount + secondaryCount;
}

// Generate gradient backgrounds based on app color theme (Green to Teal)
getSkillColor(skill: string, isPrimary: boolean = true): string {
  const appThemeGradients = [
    'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)', // Main: Green to Teal (Your app color)
    'linear-gradient(135deg, #4ade80 0%, #06d6a0 100%)', // Green to Turquoise
    'linear-gradient(135deg, #34d399 0%, #14b8a6 100%)', // Emerald to Teal
    'linear-gradient(135deg, #22c55e 0%, #0891b2 100%)', // Green to Sky
    'linear-gradient(135deg, #10b981 0%, #0284c7 100%)', // Emerald to Blue
    'linear-gradient(135deg, #059669 0%, #0369a1 100%)', // Dark Green to Blue
    'linear-gradient(135deg, #16a34a 0%, #0c7b93 100%)', // Green to Dark Teal
    'linear-gradient(135deg, #15803d 0%, #164e63 100%)', // Forest to Dark Teal
  ];
  
  const hash = skill.split('').reduce((a, b) => a + b.charCodeAt(0), 0);
  return appThemeGradients[hash % appThemeGradients.length];
}

  shouldShowRequested(items: any): boolean {

    return (items?.resumeRequested || this.util.isResumeRequested(items.candidateId, localStorage.getItem('userId'))) &&
      (!items?.resumes || items.resumes.length === 0) &&
      items?.createdBy != this.userId &&
      this.userType != 'BENCH_RECRUITER' &&
      this.userType != 'JOB_SEEKER';
  }

    shouldShowGetResume(items: any): boolean {
    const resumesPresent = Array.isArray(items.resumes) && items.resumes.length > 0;
    const condition =
      items.createdBy != this.userId &&
      !resumesPresent &&
      !this.util.isResumeRequested(items.candidateId, localStorage.getItem('userId')) &&
      !items.resumeRequested;
    return condition;
  }

// Get the date for a specific timeline step from API data
getStepDate(stepStatus: string, candidate: any): Date | null {
  if (!candidate) return null;
  
  const cacheKey = `${candidate.candidateId}_${stepStatus}`;
  
  if (this.timelineCache.has(cacheKey)) {
    return this.timelineCache.get(cacheKey);
  }
  
  // Return dates for completed steps based on mock data matching the screenshot
  if (this.isStepCompleted(stepStatus, candidate)) {
    let dateToReturn = null;
    
    switch(stepStatus.toUpperCase()) {
      case 'APPLIED':
        // Use 25 Apr 2024 to match the screenshot
        dateToReturn = new Date('2024-04-25');
        break;
      case 'SHORTLISTED':
        // Use 27 Apr 2024 to match the screenshot  
        dateToReturn = new Date('2024-04-27');
        break;
      default:
        dateToReturn = candidate.updatedOn ? new Date(candidate.updatedOn) : new Date();
    }
    
    this.timelineCache.set(cacheKey, dateToReturn);
    return dateToReturn;
  }
  
  return null;
}

// Fetch timeline data from API
async fetchTimelineData(candidateId: string, jobId?: string): Promise<any> {
  try {
    const payload = {
      entityId: jobId || this.passValues?.jobId || 'JB-0000007876',
      entityType: 'JOB',
      limit: 20,
      searchAfterKey: null,
      activityOn: candidateId,
      parentActivity: 'JOB_APPLICATION,CANDIDATE_INVITATION',
      owner: true
    };

    console.log('[CandidateCard] Fetching timeline data:', payload);
    const response = await this.apiService.create('jobs/findTimeLines', payload).toPromise();

    if (response?.data?.timeLines) {
      console.log('[CandidateCard] Timeline data received:', response.data.timeLines);

      // Use the new timeline processing logic
      this.candidateval.timelineEvents = response.data.timeLines;
      this.processTimelineForCandidate(this.candidateval);

      // Also cache timeline data for backward compatibility
      response.data.timeLines.forEach((timeline: any) => {
        const stepStatus = this.mapActivityTypeToStatus(timeline.activityType);
        if (stepStatus) {
          const cacheKey = `${candidateId}_${stepStatus}`;
          this.timelineCache.set(cacheKey, new Date(timeline.createdOn));
        }
      });

      return response.data.timeLines;
    }

    return [];
  } catch (error) {
    console.error('Error fetching timeline data:', error);
    return [];
  }
}

// Map API activity types to timeline status
private mapActivityTypeToStatus(activityType: string): string | null {
  const activityMap = {
    'JOB-APPLIED': 'APPLIED',
    'CANDIDATE-SHORTLISTED': 'SHORTLISTED', 
    'INTERVIEW-SCHEDULED': 'INTERVIEW SCHEDULED',
    'CANDIDATE-SELECTED': 'SELECTED',
    'OFFER-MADE': 'OFFERED',
    'CANDIDATE-ONBOARDED': 'ONBOARDED'
  };
  
  return activityMap[activityType] || null;
}


  @ViewChild("connectionTemplate") connectionTemplate: TemplateRef<any>
  async downloadResume(data, userId, FileId, FileName?: string) {
    if (this.isClicked) {
      return;
    }
    this.isClicked = true;
    // Always run the strip helper first — the template typically passes
    // the backend's UUID-prefixed `resume.fileName`, and the previous
    // `FileName || resolve…` order let that raw value through and the
    // saved file kept the `<uuid>_` prefix. Resolve from `data.resumes`
    // first (always stripped), fall back to the passed-in name.
    const resolvedFileName = this.resolveResumeFileName(data, FileId) || FileName || '';
    // APPLICANTS MENU ONLY - and this runs FIRST, before the resumeDownloaded check.
    // Inviting this candidate for this job already consumed one ACTIVE_INTERACTION; they
    // then applied and appear under Applicants, so the resume is already paid for and the
    // plan check must be skipped entirely.
    //
    // It has to come before `!data.resumeDownloaded`, not inside it: that flag only records
    // DOWNLOADS, so an invited candidate whose resume was downloaded once short-circuited to
    // the else branch and the check never ran at all.
    // Scoped by pageName + currentJobId, so every other screen this card renders on
    // (Marketplace, Talent Center, suggestions, …) is untouched.
    const applicantJobId = this.currentJobId || this.jobDetails?.jobId;
    const isApplicantsMenu = this.pageName === 'job-applicants' && !!applicantJobId;

    if (isApplicantsMenu
        && await this.planService.isInterestShownForJob(data.candidateId, applicantJobId)) {
      this.afterPlanValidationDownloadResume(data.candidateId, userId, data.createdBy, FileId, resolvedFileName);
      // Released here because this return skips the 5-second reset at the end.
      this.isClicked = false;
      return;
    }

    // In the APPLICANTS menu an INTEREST_NOT_FOUND answer means the slot check ALWAYS runs -
    // including for a resume this viewer downloaded before. The interest lookup, not
    // `resumeDownloaded`, is what decides whether the pair was already paid for there.
    // Every other screen keeps the original short-circuit. Your own candidate is always free.
    const needsSlotCheck = data.createdBy != this.userId
        && (isApplicantsMenu || !data.resumeDownloaded);

    if (needsSlotCheck) {
      let userData;
      try {
        userData = await this.planService.UPDATE_USERDETAILS("ACTIVE_INTERACTIONS");
      } catch (err) {
        // Eye-icon menu only: a failed plan lookup must not leave the button locked.
        // Everywhere else keeps the original behaviour, which rethrew with the lock on.
        if (isEyeIconMenu(this.router)) {
          this.isClicked = false;
        }
        throw err;
      }
      let {membershipType } = userData;
      let availablePoints = null;
      let actualPoints = null;
      let utilizedPoints = null;
      let promotional = null;

      if (userData.userDetail) {
        userData.userDetail.userPlanAndBenefits.benefitsUsages.forEach(ele => {
          if (ele.benefitKey == 'ACTIVE_INTERACTIONS') {
            availablePoints = ele.available
            actualPoints = ele.actual
            utilizedPoints = ele.utilized
            promotional = ele.promotional
          }
        });
      }
      if (userData.isExpired) {
        let popupType: "PAY" | "LIMIT"   | "UPGRADE" = "PAY";

        if (['Starter','Growth','ScaleX'].includes(membershipType)) {
          popupType = "LIMIT";
        }
        this.planService.expiredPopup("ACTIVE_INTERACTIONS", popupType, null, null, null,null, availablePoints, actualPoints, utilizedPoints, promotional);
        // Eye-icon menu only (see isEyeIconMenu): release the lock BEFORE leaving.
        // This return skipped both the success branch's reset and the 5-second
        // release timer at the end of the method, so with no slots left the lock
        // stayed on forever: the popup showed once and every later click on Download
        // Resume - and on Invite, which shares this same isClicked lock on the card -
        // hit the guard above and did nothing until the page was reloaded.
        // Every other screen that renders this card is deliberately left as it was.
        if (isEyeIconMenu(this.router)) {
          this.isClicked = false;
        }
        return;
      }
      else {
           this.afterPlanValidationDownloadResume(data.candidateId, userId, data.createdBy, FileId, resolvedFileName);
           data.resumeDownloaded = true;
           this.isClicked = false;
      }
    }
    else if (data.resumeDownloaded || data.createdBy === this.userId) {
      this.afterPlanValidationDownloadResume(data.candidateId, userId, data.createdBy, FileId, resolvedFileName);
    }
    setTimeout(() => {
      this.isClicked = false;
    }, 5000);
  }
  afterPlanValidationDownloadResume(candidateId: any, userId: any, createdBy: any, FileId: any, fileName?: string) {
    const endpoint = `candidates/resumeDownload/${candidateId}/${userId}/${createdBy}/${FileId}`;
    this.apiService.queryBlob(endpoint).subscribe(res => {
      const blob = new Blob([res]);
      this.downloadFile(blob, fileName || 'resume.pdf');
    });
  }

  /** Look up the resume's original filename from the candidate's `resumes`
   *  list (matched by `fileId`) and strip the `<uuid>_` prefix the backend
   *  prepends when it stores the file on disk. Without an extension on the
   *  saved download, the OS treats it as plain text. */
  private resolveResumeFileName(data: any, fileId: any): string {
    const list = Array.isArray(data?.resumes) ? data.resumes : [];
    const match = list.find((r: any) => r?.fileId === fileId) || list[0];
    const raw = ((match?.fileName ?? match?.name) || '').toString().trim();
    if (!raw) return '';
    const uuidPrefix = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}_/;
    return uuidPrefix.test(raw) ? raw.replace(uuidPrefix, '').trim() : raw;
  }

  downloadFile(blob: Blob, fileName: string): void {
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.append(link);
    link.click();
    link.remove();
    setTimeout(() => URL.revokeObjectURL(link.href), 0);
  }

  userTypeMap: { [key: string]: string } = {
    'FREELANCE_RECRUITER': 'Freelance Recruiter',
    'RECRUITER': 'Recruiter',
    'JOB_SEEKER': 'Job Seeker',
    'MANAGEMENT_TALENT_ACQUISITION': 'Manager',
    'MANAGEMENT TALENT ACQUISITION': 'Manager',
    'BENCH_RECRUITER': 'Bench Recruiter'
  };

  checkCurrentOrganization(): void {
    this.hasCurrentOrganization = this.candidateval?.user?.workExperience?.some(work => work?.currentOrganization) || false;
  }

  getInitials(fullname: string): string {
    return this.JobServicecolor.getInitials(fullname);
  }

  getColor(fullname: string): string {
    return this.JobServicecolor.getColor(fullname);
  }
  getFullNameTextColor(fullname: string): string {
    return this.JobServicecolor.getFullnameTextColor(fullname);
  }
  getInitialstwo(firstname: string, lastname: string): string {
    return this.JobServicecolor.getInitialsparam(firstname, lastname);
  }

  getColortwo(firstname: string, lastname: string): string {
    return this.JobServicecolor.getColorparam(firstname, lastname);
  }
  getTextColor(firstname: string, lastname: string): string {
    return this.JobServicecolor.getTextColor(firstname, lastname);
  }

  // requestResume(value , jobSupplyTemplate?: TemplateRef<any>) {
  //   this.candidateData = value;
  //   this.focus = 'candidate';
    
  //   this.apiService.query("user/profile/complete/" + localStorage.getItem('userId')).subscribe(completerres => {
  //     const totalJobs = completerres.jobsCount;
  //     // values.userId = localStorage.getItem('userId');
  //     // values.candidatefilter = true; 
  //     // values.getResume = true;

  //     if (totalJobs === 0) {
  //       this.updateResumeRequest(value);
  //     } else if ((totalJobs > 0)) {
  //         this.validatePlan(jobSupplyTemplate);
  //     }
  //   }, err => {
  //     this.util.stopLoader();
  //   }); 
    
  // }
  duplicateresume: boolean = false
  passCandidateData: any;

   requestResume(values: any, index, connectionTemplate: TemplateRef<any>, jobsupplytemplate: TemplateRef<any>) {
      this.util.startLoader();
      setTimeout(() => {
        this.duplicateresume = true;
        this.candidateData = values;  // Fixed: was passCandidateData
        this.focus = 'resume';
        this.requestresumesent(values, index, jobsupplytemplate);
        this.duplicateresume = false;
        this.util.stopLoader();
      }, 3000);
    }

    
  async requestresumesent(values, index, jobsupplytemplate) {
    try {
      const userData = await this.planService.UPDATE_USERDETAILS("ACTIVE_INTERACTIONS");
      let { userDetail, isExpired, membershipType } = userData;
      let availablePoints = null;
      let actualPoints = null;
      let utilizedPoints = null;
      let promotional = null;
      if (userDetail && userDetail.userPlanAndBenefits && userDetail.userPlanAndBenefits.benefitsUsages) {
        userDetail.userPlanAndBenefits.benefitsUsages.forEach(ele => {
          if (ele.benefitKey == 'ACTIVE_INTERACTIONS') {
            availablePoints = ele.available;
            actualPoints = ele.actual;
            utilizedPoints = ele.utilized;
            promotional = ele.promotional;
          }
        });
      } else {
        this.resumeopenmodal(values, index, jobsupplytemplate);
        this.util.stopLoader();
        return;
      }
      if (isExpired) {
        let popupType: "PAY" | "LIMIT" | "UPGRADE" = "PAY";

        if (['Starter', 'Growth', 'ScaleX'].includes(membershipType)) {
          popupType = "LIMIT";

        }

        this.planService.expiredPopup("ACTIVE_INTERACTIONS", popupType, null, null, null, null, availablePoints, actualPoints, utilizedPoints, promotional);

        this.gigsumoService.candidateInviteBtnClicked = false
        this.util.stopLoader();
        return;
      } else {
        this.resumeopenmodal(values, index, jobsupplytemplate);
      }
    } catch (error) {
    } finally {
      this.util.stopLoader();
    }

  }

    requestResumebyUser(value: any, index) {
      var data: any = {}
      data.candidateId = value.candidateId
      data.createdBy = this.userId
      data.resumeRequestLogs = [{ "jobId": null, "requestedBy": localStorage.getItem('userId') }]
      this.util.startLoader()
      this.apiService.updatePut('candidates/updateResumeRequests', data).subscribe(res => {
        if (res.code == '00000') {
          this.util.stopLoader()
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Resume request sent",
            showConfirmButton: false,
            timer: 1500,
          }).then(() => {
            value.resumeRequested = true;
  
            // if (this.passValues.length > 1) {
            //   this.passValues.splice(index, 1, value)
            // }
  
            // Updating resumeRequested to true for the matching candidateId in passValues by naaz
            this.passValues = this.passValues.map(val => {
              return val.candidateId === value.candidateId ? { ...val, resumeRequested: true } : val;
            })
          })
  
        }
      }, err => {
        this.util.stopLoader();
      });
    }

  totaljobcount: any
   resumeopenmodal(values, index, jobsupplytemplate) {
    this.apiService.query("user/profile/complete/" + localStorage.getItem('userId')).subscribe(completerres => {
      this.totaljobcount = completerres.jobsCount;
      values.userId = localStorage.getItem('userId');
      values.candidatefilter = true;
      values.userType = values.user.userType;
      values.candidateId = values.candidateId;
      values.getResume = true;

      if (this.totaljobcount == 0) {
        this.requestResumebyUser(values, index);
      } else if ((this.totaljobcount > 0)) {
        const config: ModalOptions = { class: 'modal-lg', backdrop: 'static', keyboard: false };
        this.candidateSupplyRef = this.modalService.show(jobsupplytemplate, config);

        // Load NewJobComponent dynamically after modal is rendered
        setTimeout(() => {
          this.cdr.detectChanges();
          this.loadNewJobComponent();
        }, 150);
      }
    }, err => {
      this.util.stopLoader();
    });
  }

  async validatePlan(jobSupplyTemplate) {
    const isValid : boolean = await this.pricePlanService.checkUserPlanValid("ACTIVE_INTERACTIONS");

    // if plan valid then show the template
    if(isValid){
      const config: ModalOptions = { class: 'modal-lg', backdrop: 'static', keyboard: false };
      this.candidateSupplyRef = this.modalService.show(jobSupplyTemplate, config);

      // Load NewJobComponent dynamically after modal is rendered
      setTimeout(() => {
        this.cdr.detectChanges();
        this.loadNewJobComponent();
      }, 150);
    }

  }


  updateResumeRequest(value){
    this.focus = 'resume';
    this.candidateData = value;
    var data: any = {};
    data.candidateId = value.candidateId;
    const jobId = this.appliedJobDetails && this.appliedJobDetails.jobId || null;
    data.resumeRequestLogs = [
      { jobId:jobId,
        requestedBy: localStorage.getItem("userId") 
      },
    ];
    this.util.startLoader();
    this.apiService
    .updatePut("candidates/updateResumeRequests", data)
    .subscribe(
      (res) => {
        if (res.code == "00000") {
          this.util.stopLoader();
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Resume request sent",
            showConfirmButton: false,
            timer: 2000,
          }).then(() => {
            value.resumeRequested = true;
          });
        }
      },
      (err) => {
        this.util.stopLoader();
      }
    );
  }

  /**
   * Applicant-page lock for Pre-Onboarded / Onboarded.
   *
   * Onboarding is owned by the Contract Manager page, so the Applicants list
   * must never let ANY viewer (job owner, first upstream, candidate owner)
   * actually set those two statuses. They still render in the dropdown — they
   * stay visible so users can see the full ladder — but greyed out and
   * non-clickable at every stage. Kept as a template predicate rather than a
   * flag baked into filterApplicant()'s return value so *ngFor keeps handing
   * back the same object references on each change-detection pass (cloning
   * there would re-create the menu DOM every cycle).
   */
  isStatusLocked(statusData: any): boolean {
    const itemId = typeof statusData === 'string' ? statusData : statusData?.itemId;
    return GigsumoConstants.isContractManagedApplicantStatus(itemId);
  }

  filterApplicant(data: any, nextAllowedStatuses?: string[]) {
    // Backend role guard: empty array means "view-only" (middle upstream or post-handoff first upstream).
    if (nextAllowedStatuses && Array.isArray(nextAllowedStatuses) && nextAllowedStatuses.length === 0) {
      return [];
    }
    if (this.filterApplicantData) {
      // INTERVIEW-REJECTED (Reject Interview) is now a backend-permitted transition
      // (candidate owner, at INTERVIEW-SCHEDULED). No longer suppressed here — the
      // dropdown is filtered by the backend's nextAllowedStatuses below, so the option
      // surfaces only where the backend actually accepts it.
      const arrs: Array<any> = [...this.filterApplicantData.JOB_APPLICATION_BUYER_ACTIONS.listItems];

      // When the backend provides nextAllowedStatuses, it IS the authoritative state
      // machine — see CandidateService.DIRECT_APPLY_OWNER_NEXT and firstUpstreamAllowed.
      // Use it directly so the dropdown shows every status the backend will accept
      // (e.g. INTERVIEW-REJECTED at INTERVIEW-ACCEPTED, which the legacy order/wait-flow
      // logic below was dropping because INTERVIEW-REJECTED's listvalue order didn't fit
      // the strictly forward `_x.order > order` rule). Preserves the display order from
      // arrs (sorted by the listvalue.order field).
      console.log('[filterApplicant-DEBUG candidate-card] currentStatus:', data,
          'nextAllowedStatuses:', nextAllowedStatuses,
          'arrs.itemIds:', arrs.map((x: any) => x.itemId));
      if (nextAllowedStatuses && Array.isArray(nextAllowedStatuses) && nextAllowedStatuses.length > 0) {
        let result = arrs.filter((_x: any) => nextAllowedStatuses.includes(_x.itemId));

        // L1/L2/L3 Interview options must stay hidden until the candidate has
        // reached INTERVIEW-ACCEPTED — backend's nextAllowedStatuses can list
        // them earlier (e.g. at APPLIED), so guard here too, not just in the
        // legacy fallback below.
        const interviewAcceptedStatuses = ['INTERVIEW-ACCEPTED', 'INTERVIEW_ACCEPTED', 'INTERVIEW ACCEPTED'];
        const l1l2l3Statuses = ['L1-INTERVIEW', 'L1_INTERVIEW', 'L1 INTERVIEW', 'L2-INTERVIEW', 'L2_INTERVIEW', 'L2 INTERVIEW', 'L3-INTERVIEW', 'L3_INTERVIEW', 'L3 INTERVIEW'];
        const isAfterInterviewAccepted = interviewAcceptedStatuses.includes(data) || l1l2l3Statuses.includes(data);
        if (!isAfterInterviewAccepted) {
          result = result.filter((_x: any) => !l1l2l3Statuses.includes(_x.itemId));
        }

        console.log('[filterApplicant-DEBUG candidate-card] BACKEND-DRIVEN result:', result.map((x: any) => x.itemId));
        return result;
      }
      console.log('[filterApplicant-DEBUG candidate-card] FALLBACK to legacy logic');

      const order = arrs.find(_x => _x.itemId === data)!.order;
      const lastValue: Array<any> = [];
      //  for RECRUITER ACTION

      const finalData: Array<any> = arrs.reduce((acc: Array<any>, current, _index, arr) => {

        const isAllWait = arr.some(pp => pp.wait === true);

        const find = acc.find(_d => _d.itemId === current.itemId);
        const next = arr.indexOf(current);
        const offer = arr.filter(o => (o.order === undefined || o.order === null));

        if (find === undefined) {

          const nextData = arr[next + 1];

          if (nextData && current.item != null && data === current.itemId) {
            if ((nextData.item === undefined || nextData.item === null)) {
              this.isWait = true;
              return acc;
            }
            else if (nextData.item != undefined || nextData.item != null) {
              this.isWait = false;
              return acc;
            }
          }

          if (current && current.item != undefined && current.order != undefined) {
            acc.push(current);
          }
          else if (!lastValue.includes(offer) && (current.order === undefined || current.order === null)) {
            lastValue.push(...offer);
          }

          if (this.isWait) {
            acc = [];
            if (!acc.includes(offer)) {
              acc.push(...offer);
            }
          }
        }

        return acc;
      }, []);

      let final = finalData.filter(_x => _x.order > order);
      if (!this.isWait) {
        final.push(...lastValue);
      }

      // L1/L2/L3 Interview statuses: only show after INTERVIEW-ACCEPTED (not INTERVIEW-SCHEDULED)
      const interviewAcceptedStatuses = ['INTERVIEW-ACCEPTED', 'INTERVIEW_ACCEPTED', 'INTERVIEW ACCEPTED'];
      const l1l2l3Statuses = ['L1-INTERVIEW', 'L1_INTERVIEW', 'L1 INTERVIEW', 'L2-INTERVIEW', 'L2_INTERVIEW', 'L2 INTERVIEW', 'L3-INTERVIEW', 'L3_INTERVIEW', 'L3 INTERVIEW'];
      const isAfterInterviewAccepted = interviewAcceptedStatuses.includes(data) || l1l2l3Statuses.includes(data);

      if (!isAfterInterviewAccepted) {
        // Not at interview stage yet — remove L1/L2/L3 from available options
        final = final.filter(_x => !l1l2l3Statuses.includes(_x.itemId));
      }

      // Role-based intersection: keep only statuses the backend says the current viewer may set.
      let roleFiltered: Array<any> | null = null;
      if (nextAllowedStatuses && Array.isArray(nextAllowedStatuses) && nextAllowedStatuses.length > 0) {
        final = final.filter(_x => nextAllowedStatuses.includes(_x.itemId));
        // Same filter applied to the wait-flow path so disallowed options never appear.
        roleFiltered = finalData.filter((_x: any) => nextAllowedStatuses.includes(_x.itemId));
      }

      // Once a candidate has reached the offer stage, "Withdraw Offer" must
      // remain available even if backend role guards (or order-based filtering)
      // would otherwise drop it. Reinstate it for OFFERED and any post-offer stage.
      const offerOrAbove = ['OFFERED', 'OFFER-ACCEPTED', 'PRE-ONBOARDED', 'PREONBOARDED'];
      if (offerOrAbove.includes(data)) {
        const withdrawItem = arrs.find((x: any) => x.itemId === 'OFFER-WITHDRAWN')
          || { itemId: 'OFFER-WITHDRAWN', item: 'Withdraw Offer', value: 'Withdraw Offer' };
        if (!final.some((x: any) => x.itemId === 'OFFER-WITHDRAWN')) {
          final.push(withdrawItem);
        }
        if (roleFiltered && !roleFiltered.some((x: any) => x.itemId === 'OFFER-WITHDRAWN')) {
          roleFiltered.push(withdrawItem);
        }
        if (!finalData.some((x: any) => x.itemId === 'OFFER-WITHDRAWN')) {
          finalData.push(withdrawItem);
        }
      }

      if (roleFiltered) {
        return this.isWait ? roleFiltered : final;
      }

      return this.isWait ? finalData : final;
    } else {
      // Return a default set of statuses if filterApplicantData is not available
      return [
        { itemId: 'SHORTLISTED', item: 'Shortlist', value: 'Shortlist' },
        { itemId: 'REJECTED', item: 'Reject Profile', value: 'Reject Profile' },
        { itemId: 'INTERVIEW_SCHEDULE', item: 'Interview schedule', value: 'Interview schedule' }
      ];
    }

    return [];
  }

  upgradeCandidate(item) {
    var profiledata: any = {};
    profiledata.userId = localStorage.getItem("userId");
    profiledata.userType = localStorage.getItem("userType");
    this.apiService
      .create("user/profileDetails", profiledata)
      .subscribe((res) => {
        if (
          localStorage.getItem("userType") == "student" ||
          this.userType == "JOB_SEEKER"
        ) {
          this.util.startLoader();
          const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success",
              cancelButton: "btn btn-danger",
            },
            buttonsStyling: false,
          });

          swalWithBootstrapButtons
            .fire({
              title: "Upgrading a candidate will consume $2.99 per day",
              text: "Once upgraded, this candidate will be shown under the featured category and can be seen beyond your connections. Would you like to upgrade the candidate?",
              icon: "warning",
              showCancelButton: true,

              confirmButtonText: "Yes",
              cancelButtonText: "No",
              reverseButtons: true,
              allowOutsideClick: false,
            })
            .then((result) => {
              if (result.isConfirmed) {
                item.isFeatured = true;
                this.FormData = new FormData();
                item.candidateReferenceId = item.candidateId;
                if (localStorage.getItem('MemberShipType') !== 'Free') {
                  item.businessId = localStorage.getItem('myBusinessId') || null;
                }

                // Only append resume if it's actually being uploaded (not null/empty)
                if (item.resume != null && item.resume !== '') {
                  this.FormData.append("resume", item.resume);
                }
                this.FormData.append(
                  "candidate",
                  new Blob([JSON.stringify(item)], { type: "application/json" })
                );

                this.apiService
                  .updatePut("candidates/updateCandidate", this.FormData)
                  .subscribe(
                    (res) => {
                      this.util.stopLoader();
                      if (res.code == "00000") {

                        Swal.fire({
                          icon: "success",
                          title: "Upgraded Successfully",
                          showDenyButton: false,
                          showConfirmButton: false,
                          timer: 2000,
                        });
                      }
                    },
                    (err) => {
                      this.util.stopLoader();
                    }
                  );
              }
            });
        } else {
          this.openModalWithComponent();
        }
      });
  }

  republishCandidate(item: any) {
    this.util.startLoader();
    const formData = new FormData();
    // Only append resume if it's actually being uploaded (not null/empty)
    if (item.resume != null && item.resume !== '') {
      formData.append("resume", item.resume);
    }
    formData.append("candidate", new Blob([JSON.stringify(item)], { type: "application/json" }));
    this.apiService.updatePut("candidates/updateCandidate", formData).subscribe((res) => {
      this.util.stopLoader();
      if (res.code === "00000") {
        Swal.fire({
          icon: "success",
          title: "Candidate Republished Successfully",
          showDenyButton: false,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    }, err => {
      this.util.stopLoader();
    });
  }

  removecheckbox() {
    this.removeSeletedUser.emit(this.checkedList);
  }
  @Output() candidateEmitter = new EventEmitter<{ candidateId: any; flag: string }>();


  // from this component to job-applicant --> newjobscomponent --> activity candidate;
  @Output() jobapp_to_newjob_to_atvity = new EventEmitter<any>();

  flagcandidateId: string;
  selectedItem: any;
  selectCheckbox1(event, val) {
    const checked = event.target.checked;
    this.flagcandidateId = val.candidateId;
    val.isSelected = event.target.checked;
    this.jobapp_to_newjob_to_atvity.emit({...val, checked : checked});
    this.selectedItem = val.candidateId

  }


  onNgModelChange(event, val) {
    if (event == true) {
      this.candidateEmitter.emit({ candidateId: val, flag: "true" });
    } else if (event == false) {
      this.candidateEmitter.emit({ candidateId: val, flag: "false" });
    }

  }


  getJobCssClasses(): any {
    // All status will enalbe for bussiness jobs page only
    const isBusinessJobsRoute = this.a_route.snapshot.url[0]?.path ===  'business-candidates';
    // Normal disabled based on the status for all other pages
    return {
       'disabled': !isBusinessJobsRoute && (!this.candidateval.availability || (this.candidateval?.status !='ACTIVE' && this.candidateval?.createdBy != this.userId)),
       'featured-background':this.candidateval?.isFeatured === true
     };
  }

  getActiveUrgencyDays(candidate: any): number | null {
    if (!candidate?.isFeatured) return null;

    const now = new Date();
    let urgencyEndDate: Date;

    if (candidate?.featuredConsumptions?.length > 0) {
      const lastConsumption = candidate.featuredConsumptions[candidate.featuredConsumptions.length - 1];
      const fromDate = new Date(lastConsumption.fromDate);
      const dayCount = lastConsumption.dayCount || 1;
      urgencyEndDate = new Date(fromDate.getTime() + (dayCount * 24 * 60 * 60 * 1000));
    } else if (candidate?.featuredUpdatedOn) {
      const featuredDate = new Date(candidate.featuredUpdatedOn);
      urgencyEndDate = new Date(featuredDate.getTime() + (2 * 24 * 60 * 60 * 1000));
    } else {
      return 1;
    }

    const diffMs = urgencyEndDate.getTime() - now.getTime();
    const days = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
    return days > 0 ? days : 1;
  }
  selectCheckbox() {
    this.a_route.queryParams.subscribe((res) => {
      this.getCheckedItemList();
      // var totalcredit = parseInt(res.creditPoints);
      // var points = parseInt(res.points);
      var found = this.passValues.filter((item) => item.isSelected === true);
      if (

        localStorage.getItem("userType") == "student" ||
        this.userType == "JOB_SEEKER"
      ) {
        this.passValues.every(function (item: any) {
          return item.isSelected == true;
        });
      } else {
        this.openModalWithComponent();
        return true;
      }
    });
  }

  openModalWithComponent() {
    const initialState: NgbModalOptions = {
      backdrop: "static",
      keyboard: false,
      size: "open",
    };
    this.bsModalRef = this.modalService.show(CreditModelComponent, {
      initialState,
    });
    this.bsModalRef.content.closeBtnName = "Close";
    // let data:any={}; data.sufficient=true; this.router.navigate(["checkout"], { queryParams: data });
  }

  // Get List of Checked Items
  getCheckedItemList() {
    this.checkedList = [];
    for (var i = 0; i < this.passValues.length; i++) {
      if (this.passValues[i].isSelected) {
        this.checkedList.push(this.passValues[i]);
      }
    }

    this.checkedList = JSON.stringify(this.checkedList);
    this.selectedCandidate.emit(this.checkedList);
  }
  isClicked: boolean = false;
  candidateData: any;
  focus: string;
  invite(values: any, connectionModal?: TemplateRef<any>, jobSupplyTemplate?: TemplateRef<any>) {
    if (this.isClicked) {
      return;
    }

    this.util.startLoader();
    this.isClicked = true;
    this.candidateData = values;
    this.focus = 'candidate';

    // this.checkConnectionStatus(values)
    //   .subscribe(response => {
        //if (values.isFeatured == true) {
          if (isEyeIconMenu(this.router)) {
            // Eye-icon menu only: release the lock the moment the attempt settles,
            // instead of on the blind 5-second timer. With no slots left
            // proceedToInvite shows the popup and returns almost at once, but the
            // lock stayed on for the full 5 seconds: close the popup and click
            // Invite again inside that window and nothing happened. On success it
            // resolves once the job picker is open, and that modal's static
            // backdrop already blocks a second click on the card.
            this.proceedToInvite(values, jobSupplyTemplate)
              .finally(() => { this.isClicked = false; });
          } else {
            // Every other screen keeps the original behaviour unchanged.
            this.proceedToInvite(values, jobSupplyTemplate);
            setTimeout(() => {
              this.isClicked = false;
            }, 5000);
          }
       // } else if (values.isFeatured == false || values.isFeatured == null) {
          // if (response.data.connectionStatus === 'CONNECTED') {
          //   this.proceedToInvite(values, jobSupplyTemplate);
          // } else if (response.data.connectionStatus !== 'CONNECTED') {
          //   this.proceedToInvite(values, jobSupplyTemplate);
            // to be used later
            // this.openConnectionTemplate(response.data.connectionStatus, values, connectionModal);
          //}
      //  }
      //})
  }

  openConnectionTemplate(connectionStatus, values, connectionTempate?: TemplateRef<any>) {
    this.connectionStatus = connectionStatus;
    this.values = values;
    const initialState: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      size: 'sm',
    };
    this.apiService.query("user/" + this.values.createdBy).subscribe(res => {
      if (res.code == '00000') {
        this.counterpartsDetails = res;
        this.connectionRequestRef = this.modalService.show(connectionTempate, initialState);
      }
    })
  }

  checkConnectionStatus(values): Observable<any> {
    const apiURL = 'user/checkConnectionStatus';
    const params = new HttpParams()
      .set('userId', this.userId)
      .set('connnectorId', values.createdBy);

    const urlWithParams = `${apiURL}?${params.toString()}`;
    return this.apiService.query(urlWithParams);
  }

  async proceedToInvite(values, jobsupplytemplate) {
    this.util.startLoader();
    const userData = await this.planService.UPDATE_USERDETAILS("ACTIVE_INTERACTIONS");
    let {membershipType } = userData;
    if (userData.isExpired) {
      this.util.stopLoader();
      let availablePoints = null;
      let actualPoints = null;
      let utilizedPoints = null;
      let promotional = null;
      userData.userDetail.userPlanAndBenefits.benefitsUsages.forEach(ele => {
        if (ele.benefitKey == 'ACTIVE_INTERACTIONS') {
          this.util.stopLoader();
          availablePoints = ele.available
          actualPoints = ele.actual
          utilizedPoints = ele.utilized
          promotional = ele.promotional
        }
      })
      let popupType: "PAY" | "LIMIT"   | "UPGRADE" = "PAY";

      if (['Starter','Growth','ScaleX'].includes(membershipType)) {
        popupType = "LIMIT";
      }
      this.planService.expiredPopup("ACTIVE_INTERACTIONS", popupType, null, null, null,null, availablePoints, actualPoints, utilizedPoints, promotional);

      return;
    }
    values.userId = localStorage.getItem('userId');
    values.candidatefilter = true;
    values.getResume = false;
    values.userType = values.user ? values.user.userType : null;
    const config: ModalOptions = { class: 'modal-lg', backdrop: 'static', keyboard: false };
    this.candidateSupplyRef = this.modalService.show(jobsupplytemplate, config);

    // Load NewJobComponent dynamically after modal is rendered
    setTimeout(() => {
      this.cdr.detectChanges();
      this.loadNewJobComponent();
    }, 150);

    this.util.stopLoader();
  }

  afterValidatingPlan(values: any) {
    values.userId = localStorage.getItem("userId");
    values.candidatefilter = true;
    values.userType = values.user.userType;
    this.router.navigate(["newjobs"], { queryParams: values });
  }


  backdropConfig = {
    backdrop: true,
    ignoreBackdropClick: true,
    keyboard: false,
    // scroll
  };
  modalRef: BsModalRef;
  closemodel() {
    this.modalRef.hide();
  }
  purchesCredits(buyCredit: TemplateRef<any>) {
    this.modalRef.hide();
    this.modalRef = this.modalService.show(buyCredit, this.backdropConfig);
  }
  get credit() {
    return this.creditform.controls;
  }
  buycredit(id) {
    this.submited = true;
    if (id != "noval") {
      this.creditform.patchValue({ point: id });
    }
    if (this.creditform.valid) {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "info",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            if (this.creditform.valid) {
              this.submited = false;
              let data: any = {};
              (data.userId = localStorage.getItem("userId")),
                //(data.totalPoints = this.creditform.value.point);
                this.util.startLoader();
              this.apiService.create("credits/buyCredits", data).subscribe(
                (res) => {
                  this.util.stopLoader();
                  this.creditform.reset();
                  this.modalRef.hide();
                  this.showmodel = false;

                  if (res.code == "00000") {
                    Swal.fire({
                      icon: "success",
                      title: "Credit Added Successfully",
                      showDenyButton: false,
                      // confirmButtonText: `ok`,
                      showConfirmButton: false,

                      timer: 2000,
                    });
                    this.creditform.reset();
                  }
                },
                (err) => {
                  this.util.stopLoader();
                }
              );
            } else if (this.creditform.invalid) {
              this.submited = true;
            }
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            this.creditform.reset();
          }
        });
    }
  }

  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    // setTimeout(() => {
    //   if(document.getElementById('zerocandidates') != null){
    //     document.getElementById('zerocandidates').style.visibility = "visible";
    //   }
    //   if(document.getElementById('fetching')!=null){
    //     document.getElementById('fetching').style.visibility = "hidden"
    //   }
    // },5000)
  }

  like(values: any) {
    if (values.isProcessingLike) return;
    if (values.createdBy != localStorage.getItem("userId")) {
      let datas: any = {};
      datas.candidateId = values.candidateId;
      datas.userId = localStorage.getItem("userId");

      const likeStatus = values.isLiked === true ? "UNLIKE" : "LIKE";

      values.isProcessingLike = true;
      this.util.startLoader();
      datas.likeStatus = likeStatus;

      this.apiService.updatePut("candidates/updateCandidateLiked", datas).subscribe((res) => {
        if (res.code == "00000") {
          this.util.stopLoader();
          this.candidateval.isLiked = res.data.candidateData.isLiked;
          this.candidateval.likesCount = res.data.candidateData.likesCount;
        }
        values.isProcessingLike = false;
      }, err => {
        values.isProcessingLike = false;
        this.util.stopLoader();
      });
    }else{
      this.goTo(values, 'Clike-like')
    }
  }

  goTo(values: any, param) {
    if (values.createdBy == this.userId) {
      if (param == "jobsApplied") {
        this.router.navigate(['newcandidates'], { queryParams: { candidateId: values.candidateId, tabName: 'jobsApplied', From: this.From } })
      } else if (param == "views") {
        this.router.navigate(['newcandidates'], { queryParams: { candidateId: values.candidateId, tabName: 'views', From: this.From } })

      } else if (param == "Clike-like") {
        this.router.navigate(['newcandidates'], { queryParams: { candidateId: values.candidateId, tabName: 'Clike-like', From: this.From } })

      } else if (param == "cInvited" && values.interestShownCount > 0) {
        this.router.navigate(['newcandidates'], { queryParams: { candidateId: values.candidateId, tabName: 'cInvited', From: this.From } })

      }
    } else if (values.createdBy != this.userId) {
      if (param == "jobsApplied") {
        this.router.navigate(['newcandidates'], { queryParams: { candidateId: values.candidateId, tabName: 'profileSummary', From: this.From } })
      } else if (param == "views" && values.viewedByCount > 0) {
        this.router.navigate(['newcandidates'], { queryParams: { candidateId: values.candidateId, tabName: 'profileSummary', From: this.From } })
      } else if (param == "cInvited" && values.interestShownCount > 0) {
        this.router.navigate(['newcandidates'], { queryParams: { candidateId: values.candidateId, tabName: 'profileSummary', From: this.From } })
      }
    }
  }

  async open(values: any) {


    if (values.createdBy != this.userId && !values.isViewed) {

      this.updateCandidateView(values);

    }
    else {
      this.router.navigate(["newcandidates"], { queryParams: { candidateId: values.candidateId, tabName: 'profileSummary', From: this.From } });
    }
  }

  updateCandidateView(values: any) {
    this.util.startLoader();
    this.candidateService.updateCandidateViewed(values).subscribe((res) => {
      this.util.stopLoader();
      if (res.code === "00000") {
        this.router.navigate(["newcandidates"], { queryParams: { candidateId: values.candidateId, tabName: 'profileSummary', From: this.From } });
      }
    },
      (err) => {
        this.util.stopLoader();
      });
  }

  isExcludedStatus(status: string): boolean {
    if (this.filterApplicantData) {
      const find = this.filterApplicantData.JOB_APPLICATION_BLOCKING_ACTIONS.listItems &&
        this.filterApplicantData.JOB_APPLICATION_BLOCKING_ACTIONS.listItems.find(x => x.itemId === status);
      return find ? true : false;
    }
  }

  get rtrFormControls() {
    return this.rtrformgrp.controls;
  }

  negativeStauses = ['REJECTED','PROFILE-REJECTED','INTERVIEW-REJECTED','INTERVIEW-FAILED','OFFER-DECLINED','CANDIDATE-WITHDRAWN','OFFER-WITHDRAWN'];
  validateNegativeStatus(datas: any, value: any, interviewPayrateTemplate?: TemplateRef<any>){
    console.warn('status to update : ', datas.itemId);

    const targetStatus = datas.itemId;
    // Read the candidate's current stage so we can decide if the gate
    // has already been crossed (see "Payrate gate" block below).
    const currentStatus = (this.candidateval?.currentStatus || value?.currentStatus || '').toString().toUpperCase();

    const membershipType = localStorage.getItem('MemberShipType');
    const userType = localStorage.getItem('userType');
    const isFreeOrJobSeeker = membershipType === 'Free' || userType === 'JOB_SEEKER';

    // JOB_SEEKER with non-Corp-to-Corp: no payrate popup at ANY stage, just update status directly
    if (userType === 'JOB_SEEKER') {
      const engType = this.candidateval?.engagementType;
      const isCorpToCorp = engType === 'Corp to Corp' || engType === 'Corp To Corp';
      if (!isCorpToCorp) {
        if (this.negativeStauses.includes(targetStatus)) {
          const swalWithBootstrapButtons = Swal.mixin({
            customClass: { confirmButton: 'btn btn-success', cancelButton: 'btn btn-danger' },
            buttonsStyling: false
          });
          swalWithBootstrapButtons.fire({
            title: 'Are you sure you want to ' + this.prepareMessage(targetStatus) + '?',
            html: `Once you ${this.prepareMessage(targetStatus)}, the candidate will no longer be considered for this job.<br><p>This action cannot be undone.</p>`,
            icon: 'warning', showCancelButton: true, confirmButtonText: 'Yes', cancelButtonText: 'Cancel', reverseButtons: true
          }).then(result => { if (result.isConfirmed) { this.updatestatus(datas, value); } });
        } else {
          this.updatestatus(datas, value);
        }
        return;
      }
    }

    // ── Payrate gate ──────────────────────────────────────────────────
    // The Rate-Confirmation modal creates the contract-candidate record
    // on the backend, so it should fire ONCE per candidate — only when
    // the candidate is *first* crossing into a "rated" stage. Earlier
    // logic opened the modal for every payrate-adjacent status change
    // (INTERVIEW-SCHEDULED → ONBOARDED), which re-prompted the recruiter
    // every time and tried to re-create a contract that already exists.
    //
    // Trigger stages   — opening the modal is the gate transition itself.
    // Past-gate stages — the candidate is already at or beyond the gate;
    //                    the contract exists, so subsequent moves
    //                    (incl. PRE-ONBOARDED / ONBOARDED) skip the modal.
    // Anything else    — never opens the modal (SHORTLISTED, INTERVIEW-
    //                    SCHEDULED, L1/L2/L3-INTERVIEW, etc).
    // Locked 2026-06-08 — payrate modal fires ONLY at OFFERED. Prior versions
    // also fired at SELECTED / CANDIDATE-SELECTED, but per owner direction the
    // rate-confirmation is now anchored to the offer moment, not to selection.
    // ContractCandidate row creation moves with it (it's the side effect of
    // the modal's submit). SELECTED / CANDIDATE-SELECTED targets now flow
    // through normal updatestatus, no rate prompt.
    const TRIGGER_STAGES = ['OFFERED'];
    // VALIDATE_STAGES — call /validate-b2b-connection but do NOT open the
    // PayRate modal. Used to enforce the FREE-plan job-owner block (10006)
    // when advancing the candidate to INTERVIEW-SCHEDULED or above.
    const VALIDATE_STAGES = [
      'INTERVIEW-SCHEDULED',
      'L1-INTERVIEW', 'L2-INTERVIEW', 'L3-INTERVIEW',
      'OFFER-ACCEPTED',
      'PRE-ONBOARDED', 'PREONBOARDED',
      'ONBOARDED'
    ];
    // Locked 2026-06-08 — SELECTED / CANDIDATE-SELECTED dropped from PAST_GATE
    // alongside TRIGGER_STAGES. If they stayed here, a candidate sitting at
    // SELECTED moving to OFFERED would hit isPastGate=true and skip the modal —
    // exactly the opposite of what we want now that OFFERED is the only gate.
    const PAST_GATE_STAGES = [
      'OFFERED', 'OFFER-ACCEPTED',
      'PRE-ONBOARDED', 'PREONBOARDED',
      'ONBOARDED'
    ];
    const offerAndAbove = ['OFFERED', 'OFFER-ACCEPTED', 'PRE-ONBOARDED', 'PREONBOARDED', 'ONBOARDED'];

    const isTriggerStage   = TRIGGER_STAGES.includes(targetStatus);
    const isValidateStage  = VALIDATE_STAGES.includes(targetStatus);
    const isPastGate       = PAST_GATE_STAGES.includes(currentStatus);
    const isOfferStageOrAbove = offerAndAbove.includes(targetStatus);

    if (isTriggerStage && !isPastGate) {
      if (isFreeOrJobSeeker) {
        if (isOfferStageOrAbove) {
          // Free Plan / JOB_SEEKER Corp-to-Corp at OFFERED+: call validate API
          if (interviewPayrateTemplate) {
            this.validateB2bAndOpenPayrate(datas, value, interviewPayrateTemplate);
          } else {
            this.validateB2bAndOpenPayrate(datas, value, null);
          }
        } else {
          // Free Plan / JOB_SEEKER Corp-to-Corp at SELECTED / CANDIDATE-SELECTED:
          // call validate-b2b-connection (no template — no Pay-Rate modal at this
          // pre-OFFER stage). This lets the backend's 10006 gate fire and block
          // FREE-plan job owners who try to skip INTERVIEW-SCHEDULED and jump
          // straight to SELECTED/OFFERED. JOB_SEEKER viewers without a business
          // are auto-skipped by the gate (jobOwnerBusinessId guard) and proceed
          // through the normal skipContractCreation success path.
          this.validateB2bAndOpenPayrate(datas, value, null);
        }
        return;
      }
      // Paid plan crossing into a rated stage for the first time —
      // validate B2B and (on success) open the RTR modal.
      if (interviewPayrateTemplate) {
        this.validateB2bAndOpenPayrate(datas, value, interviewPayrateTemplate);
        return;
      }
    }

    // Validate-only stages — call the API to surface the FREE-plan
    // job-owner block (10006). On success, no modal opens; status updates
    // proceed normally. On 10006, the validate handler shows the
    // "Purchase Plan" popup and the status change is aborted.
    if (isValidateStage) {
      this.validateB2bAndOpenPayrate(datas, value, null);
      return;
    }

    // validate negative status for confirmation
    if (this.negativeStauses.includes(datas.itemId)) {
  
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger'
        },
        buttonsStyling: false
      });
  
      swalWithBootstrapButtons.fire({
        title: 'Are you sure you want to '+ this.prepareMessage(datas.itemId) + '?',
        html: `Once you ${this.prepareMessage(datas.itemId)}, the candidate will no longer be considered for this job.<br>
        <p>This action cannot be undone.</p>`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
        reverseButtons: true
      }).then(result => {
        if(result.isConfirmed){
          this.updatestatus(datas,value);
        }
      });
    }else {
      this.updatestatus(datas,value);
    }
  }

  prepareMessage(sts:any):string {
    if(sts == 'INTERVIEW-FAILED'){
      return 'reject interview';
    }else if(sts == 'OFFER-WITHDRAWN'){
      return 'withdraw offer';
    }else if(sts == 'PROFILE-REJECTED'){
      return 'reject profile'
    }else if(sts == 'CANDIDATE-WITHDRAWN'){
      return 'withdraw';
    }else if(sts == 'OFFER-DECLINED'){
      return 'decline offer'
    }
  }

  // --- RTR Payrate Modal ---

  isPayrateReadonly: boolean = false;

  private validateB2bAndOpenPayrate(datas: any, value: any, template: TemplateRef<any>): void {
    const userId = localStorage.getItem('userId') || '';
    // openPayRate (manual "Pay Rate" button) passes datas=null — there's no
    // target status from a dropdown click, so fall back to the candidate's
    // current status. Without this the validate-b2b payload would omit
    // candidateCurrentStatus, and the backend can't tell SELECTED+ from
    // pre-OFFER and falls into the safe skipContractCreation branch — which
    // hides supplierBusinessId / b2bContactId from the response.
    const targetStatus = datas?.itemId
        || value?.currentStatus
        || this.candidateval?.currentStatus
        || '';
    this.util.startLoader();
    this.apiService.query(`business/findUserRoleInBusiness/${userId}`).subscribe({
      next: (res: any) => {
        const businessId = res?.data?.businessData?.businessId;
        if (!businessId) {
          // JOB_SEEKER may not have a business — check userType
          const userType = localStorage.getItem('userType');
          if (userType === 'JOB_SEEKER') {
            this.util.stopLoader();
            // JOB_SEEKER without business: proceed with status update directly
            this.updatestatus(datas, value);
            return;
          }
          this.util.stopLoader();
          Swal.fire({ icon: 'warning', title: 'Business not found', text: 'Unable to determine your business. Please try again.', showConfirmButton: true });
          return;
        }
        const candidateId = value.candidateId || value.contractData?.candidateId || '';
        const jobId = this.jobId || value.contractData?.jobId || '';
        this.contractCandidateService.validateB2bConnection(businessId, jobId, candidateId, targetStatus).subscribe({
          next: (b2bRes: any) => {
            this.util.stopLoader();
            if (b2bRes?.code === '00000') {
              // Check if backend says to skip contract creation (Free plan / JOB_SEEKER)
              // OR validate-only path (no template) — proceed without opening the modal.
              if (b2bRes.data?.skipContractCreation || !template) {
                this.updatestatus(datas, value);
                return;
              }
              this.b2bData = b2bRes.data;
              this.openInterviewPayrateModal(datas, value, template);
            } else if (b2bRes?.code === '99996') {
              // Mandatory-document gate. PRE-ONBOARDED / ONBOARDED are in
              // VALIDATE_STAGES, so the dropdown reaches the blocker through
              // THIS method — not the handler further down the file. Without
              // this branch it fell into the final else and showed the generic
              // "Validation Failed" + the raw backend sentence.
              this.contractCandidateService.showMandatoryDocumentPopup();
            } else if (b2bRes?.code === '10004') {
              // Free plan — show purchase business plan message
              Swal.fire({
                icon: 'warning',
                title: 'Business Plan Required',
                html: b2bRes.message || 'Please purchase a business plan to proceed with the next process.',
                confirmButtonText: 'OK',
                showCancelButton: false
              });
            } else if (b2bRes?.code === '10006') {
              // FREE-plan job owner trying to advance to INTERVIEW-SCHEDULED or above —
              // block with the "Purchase Plan" popup and abort the status change.
              Swal.fire({
                icon: 'warning',
                title: 'Plan Required',
                html: b2bRes.message || 'You need to purchase a plan to hire the candidate.',
                confirmButtonText: 'OK',
                showCancelButton: false
              });
            } else if (b2bRes?.code === '10005') {
              // Corp-to-Corp JOB_SEEKER — no organization found
              Swal.fire({
                icon: 'warning',
                title: 'Organization Required',
                html: b2bRes.message || 'Corp-to-Corp candidates must have an active organization.',
                confirmButtonText: 'OK'
              });
            } else if (b2bRes?.code === '10001') {
              Swal.fire({
                icon: 'warning',
                title: 'Candidate Not Linked to a Business',
                text: 'This candidate must be associated with a business before a contract can be created.',
                confirmButtonText: 'OK'
              });
            } else if (b2bRes?.code === '10002') {
              // Supplier-side path (candidate owner advancing / ACCEPTING the offer): they need to
              // connect with the CUSTOMER (job owner), so pre-fill the customer in the Add Business
              // form. (Initiate Contract — the customer-side action — pre-fills the supplier instead.)
              const customerBusinessId = b2bRes.data?.customerBusinessId || '';
              const customerBusinessName = b2bRes.data?.customerBusinessName || '';
              Swal.fire({
                icon: 'warning',
                title: 'Business Connection Required',
                text: 'You need to establish a business connection before moving this candidate to the next stage. Would you like to go to Business Contacts to set up the connection?',
                showCancelButton: true,
                confirmButtonText: 'Yes, Go to Business Contacts',
                cancelButtonText: 'Cancel',
                confirmButtonColor: '#8B5CF6',
                cancelButtonColor: '#6c757d',
                reverseButtons: true
              }).then(result => {
                if (result.isConfirmed) {
                  this.router.navigate(['/user-management/businessContacts'], {
                    queryParams: customerBusinessId ? { customerBusinessId, customerBusinessName } : {}
                  });
                }
              });
            } else if (b2bRes?.code === '10003') {
              Swal.fire({
                icon: 'warning',
                title: 'Business Connection Required',
                text: 'Contact Super Admin to initiate business connection with supplier.',
                confirmButtonText: 'OK'
              });
            } else if (b2bRes?.code === '10004') {
              // B2B invite already sent and pending peer acceptance — alert only.
              // Routing to the Add Business form here would let the user send a
              // duplicate invite (the reported 2026-06-15 bug).
              Swal.fire({
                icon: 'info',
                title: 'B2B Connection Pending',
                text: b2bRes?.message
                  || 'A B2B connection request has already been sent and is awaiting acceptance from the other business. Please wait for them to accept before proceeding.',
                confirmButtonText: 'OK'
              });
            } else {
              Swal.fire({ icon: 'error', title: 'Validation Failed', text: b2bRes?.message || 'B2B connection validation failed.', showConfirmButton: true });
            }
          },
          error: () => {
            this.util.stopLoader();
            Swal.fire({ icon: 'error', title: 'Error', text: 'Failed to validate B2B connection.', showConfirmButton: true });
          }
        });
      },
      error: () => {
        this.util.stopLoader();
        Swal.fire({ icon: 'error', title: 'Error', text: 'Failed to fetch business details.', showConfirmButton: true });
      }
    });
  }

  /**
   * Locked 2026-06-08 — resolve which tierPayRate row applies to the viewer.
   *   1. Prefer the tier the viewer THEMSELVES published (customerBusinessId match).
   *   2. Fall back to the immediate-upstream tier where viewer is the supplier —
   *      catches mid-chain joiners (e.g. BoschParts added after publish).
   *   3. Final fallback: the first tier in the list (job-owner's tier).
   * Returns null when tierPayRates is empty / missing.
   */
  private resolveViewerTier(viewerBizId: string, job: any): any {
    const tiers = job?.tierPayRates || [];
    if (!tiers.length || !viewerBizId) return null;
    const owned = tiers.find((t: any) => t?.customerBusinessId
        && t.customerBusinessId.toLowerCase() === viewerBizId.toLowerCase());
    if (owned) return owned;
    const upstream = tiers.find((t: any) => t?.supplierBusinessId
        && t.supplierBusinessId.toLowerCase() === viewerBizId.toLowerCase());
    if (upstream) return upstream;
    // Locked 2026-06-10 — first-tier fallback removed. Let patchPayrateCeiling
    // fall through to JobDetails.targetRateTo + payType instead of silently
    // using the job-owner's tier as the "Submitted for" ceiling for every viewer.
    return null;
  }

  private patchPayrateCeiling(value: any): void {
    const viewerBizId = localStorage.getItem('myBusinessId')
        || localStorage.getItem('businessId') || '';
    const job = this.appliedJobDetails || value?.jobDetails;
    const tier = this.resolveViewerTier(viewerBizId, job);
    // Locked 2026-06-10 — fallback when tierPayRates has no row for the viewer's
    // (customerBusinessId, supplierBusinessId) pair: read the ceiling from
    // JobDetails directly. Two-tier read:
    //   tier match (per-supplier) > JobDetails.targetRateTo (job-level)
    const submittedToRate = tier?.toPayRate ?? job?.targetRateTo ?? null;
    const submittedRateType = tier?.rateType ?? job?.payType ?? 'Hourly';
    // Locked 2026-06-10 — Offer For initial value mirrors Submitted For. Offer For
    // stays editable; Submitted For is read-only. Both rows pre-fill with the
    // same tier (or JobDetails fallback) value so the user adjusts Offer For from
    // a sensible default instead of starting blank.
    this.rtrformgrp.patchValue({
      submittedToRate,
      submittedRateType,
      offerRate: submittedToRate,
      offerRateType: submittedRateType,
      country: value?.country || '',
      termsandcondition: null
    });
    // Apply ceiling validator on offerRate ONLY when we have a real ceiling.
    const offerCtrl = this.rtrformgrp.get('offerRate');
    if (offerCtrl) {
      const validators = [Validators.required, CustomValidator.validDecimal(), CustomValidator.checkWhiteSpace()];
      if (typeof submittedToRate === 'number' && submittedToRate > 0) {
        validators.push(Validators.max(submittedToRate));
      }
      offerCtrl.setValidators(validators);
      offerCtrl.updateValueAndValidity({ emitEvent: false });
    }
  }

  openInterviewPayrateModal(datas: any, value: any, template: TemplateRef<any>): void {
    console.log('openInterviewPayrateModal - candidate details:', value);
    console.log('openInterviewPayrateModal - job details:', { jobId: this.jobId, jobTitle: this.jobTitle, appliedJobDetails: this.appliedJobDetails });
    this.pendingOfferedData = datas;
    this.pendingOfferedCandidate = value;
    this.submitRTR = false;
    this.rtrformgrp.reset();
    this.patchPayrateCeiling(value);

    const modalOptions: ModalOptions = { class: 'modal-md', backdrop: 'static', keyboard: false };
    this.rtrModalRef = this.modalService.show(template, modalOptions);
  }

  openPayrateModal(datas: any, value: any, template: TemplateRef<any>): void {
    this.pendingOfferedData = datas;
    this.pendingOfferedCandidate = value;
    this.submitRTR = false;
    this.rtrformgrp.reset();
    this.patchPayrateCeiling(value);
    const modalOptions: ModalOptions = { class: 'modal-md', backdrop: 'static', keyboard: false };
    this.rtrModalRef = this.modalService.show(template, modalOptions);
  }

  submitPayrate(): void {
    this.submitRTR = true;
    if (this.rtrformgrp.invalid) return;

    // Locked 2026-06-08 — UI form controls are offerRate / offerRateType; wire format
    // stays targetRate / payType so existing /contractCandidate/create + entity
    // mapping continues to work without changes.
    const payload = {
      jobId: this.jobId,
      candidateId: this.pendingOfferedCandidate.candidateId,
      candidateStatus: this.pendingOfferedData?.itemId || this.candidateval.currentStatus,
      createdBy: this.userId,
      targetRate: parseFloat(this.rtrformgrp.value.offerRate),
      payType: this.rtrformgrp.value.offerRateType,
      customerBusinessId: this.b2bData?.customerBusinessId || '',
      supplierBusinessId: this.b2bData?.supplierBusinessId || '',
      b2bContactId: this.b2bData?.b2bContactId || '',
      isSubContracted: this.b2bData?.subContracted || false
    };

    console.table(payload);
    this.util.startLoader();
    this.contractCandidateService.createCandidate(payload).subscribe({
      next: (res) => {
        if (res.code === '00000') {
          // Capture before hidePayrateModal nulls them out
          const offeredData = this.pendingOfferedData;
          const offeredCandidate = this.pendingOfferedCandidate;
          this.hidePayrateModal();

          // Show auto-created external supplier notification if present
          if (res.data?.autoCreatedExternalBusiness) {
            const bizName = res.data.autoCreatedExternalBusiness.businessName || 'Unknown';
            Swal.fire({
              icon: 'info',
              title: 'External Supplier Created',
              text: `External Supplier auto-created: ${bizName}`,
              showConfirmButton: false,
              timer: 3000
            });
          }

          if (offeredData) {
            this.updatestatus(offeredData, offeredCandidate);
          } else {
            Swal.fire({
              icon: 'success',
              title: 'Payrate updated Successfully',
              showConfirmButton : false,
              timer : 2000
            });
            this.util.stopLoader();
          }
        } else if (res.code === '00001') {
          this.util.stopLoader();
          this.hidePayrateModal();
          Swal.fire({
            title: 'Business Connection Required',
            text: 'You need to establish a business connection before moving this candidate to the next stage. Would you like to go to Business Contacts to set up the connection?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, Go to Business Contacts',
            cancelButtonText: 'Cancel',
            confirmButtonColor: '#8B5CF6',
            cancelButtonColor: '#6c757d'
          }).then((result) => {
            if (result.isConfirmed) {
              this.router.navigate(['/user-management/businessContacts']);
            }
          });
        } else if (res.code === '10001') {
          this.util.stopLoader();
          this.hidePayrateModal();
          Swal.fire({
            icon: 'warning',
            title: 'Candidate Not Linked to a Business',
            text: 'This candidate must be associated with a business before a contract can be created.',
            confirmButtonText: 'OK'
          });
        } else if (res.code === '10002') {
          this.util.stopLoader();
          this.hidePayrateModal();
          const supplierBusinessId = res.data?.supplierBusinessId || '';
          Swal.fire({
            title: 'No B2B Connection Found',
            text: 'These two businesses are not connected. Would you like to go to Business Contacts to establish the connection?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, Go to Business Contacts',
            cancelButtonText: 'Cancel',
            confirmButtonColor: '#8B5CF6',
            cancelButtonColor: '#6c757d'
          }).then(result => {
            if (result.isConfirmed) {
              this.router.navigate(['/user-management/businessContacts'], {
                queryParams: supplierBusinessId ? { supplierBusinessId } : {}
              });
            }
          });
        } else if (res.code === '10004') {
          // B2B invite already pending peer acceptance — alert only, no route.
          this.util.stopLoader();
          this.hidePayrateModal();
          Swal.fire({
            icon: 'info',
            title: 'B2B Connection Pending',
            text: res?.message
              || 'A B2B connection request has already been sent and is awaiting acceptance from the other business. Please wait for them to accept before proceeding.',
            confirmButtonText: 'OK'
          });
        } else {
          this.util.stopLoader();
          Swal.fire('Error', res.message || 'Failed to create contract candidate', 'error');
        }
      },
      error: (err) => {
        this.util.stopLoader();
        Swal.fire('Error', 'Failed to create contract candidate', 'error');
      }
    });
  }

  hidePayrateModal(): void {
    if (this.rtrModalRef) {
      this.rtrModalRef.hide();
    }
    setTimeout(() => {
      this.rtrformgrp.reset();
      this.submitRTR = false;
      this.pendingOfferedData = null;
      this.pendingOfferedCandidate = null;
    }, 1000);
  }

  updatestatus(datas, value) {

    this.util.startLoader();
    var data: any = {};
    data.jobId = this.jobId || this.candidateval?.contractData?.jobId;
    data.candidateId = value.candidateId;
    data.currentStatus = datas.itemId;
    data.candidateName = this.candidateval.firstName + " " + this.candidateval.lastName;
    data.jobTitle = this.jobTitle || this.candidateval?.contractData?.jobTitle || this.candidateval?.jobTitle;
    data.createdByUserName = this.postedByUserName || '';
    data.createdBy = value.createdBy || '';
    data.email = this.candidateval?.user?.email || this.candidateval?.email || '';

    this.jobupdatestatus(data, value);
  }

  async jobupdatestatus(data,candidate?:any) {
    // ----- TEMPORARY free-plan gate (reduces data issues; full free-plan handling is a separate
    // effort). OFFER-ACCEPTED -> candidate owner accepting -> check the CANDIDATE OWNER's plan.
    // CANDIDATE-SELECTED / OFFERED / PRE-ONBOARDED / ONBOARDED -> job owner advancing -> check the
    // acting (logged-in) business's plan. Only code 10004 (free/null plan) blocks; any other code
    // or error proceeds, so Business-plan (paid) users are never blocked. -----
    {
      const planStatus = (data.currentStatus || '').toUpperCase();
      const ownerPlanStatuses = ['OFFER-ACCEPTED'];
      const actorPlanStatuses = ['CANDIDATE-SELECTED', 'OFFERED', 'PRE-ONBOARDED', 'ONBOARDED'];
      if (ownerPlanStatuses.includes(planStatus) || actorPlanStatuses.includes(planStatus)) {
        this.util.startLoader();
        try {
          let planRes: any;
          if (ownerPlanStatuses.includes(planStatus)) {
            planRes = await this.contractCandidateService.validateBusinessPlan(data.candidateId, '').toPromise();
          } else {
            const userId = localStorage.getItem('userId') || '';
            let actorBusinessId = '';
            try {
              const roleRes: any = await this.apiService.query(`business/findUserRoleInBusiness/${userId}`).toPromise();
              actorBusinessId = roleRes?.data?.businessData?.businessId || '';
            } catch (e) { actorBusinessId = ''; }
            planRes = await this.contractCandidateService.validateBusinessPlan('', actorBusinessId).toPromise();
          }
          if (planRes?.code === '10004') {
            this.util.stopLoader();
            Swal.fire({
              icon: 'warning',
              title: 'Business Plan Required',
              html: "You can't proceed to the next stage on the Free plan. Please purchase a Business Plan to continue.",
              confirmButtonText: 'OK'
            });
            return;
          }
        } catch (e) { /* don't hard-block on a plan-check error */ }
        this.util.stopLoader();
      }
    }

    // Hard-block OFFER-ACCEPTED / PRE-ONBOARDED / ONBOARDED when there is no B2B
    // connection between the viewer (job owner) and the candidate's business.
    // Mirrors job-card.component.ts:515-573 so both row-design and job-card views
    // enforce the same gate. Without this, the candidate-card path sent the status
    // straight to /updatejobAppliedStatus with no B2B pre-check — letting Ford
    // accept an Infosys candidate's offer even when Ford ↔ Infosys are not
    // connected as B2B contacts.
    const b2bGatedStatuses = ['OFFER-ACCEPTED', 'PRE-ONBOARDED', 'ONBOARDED'];
    const needsB2bCheck = b2bGatedStatuses.includes((data.currentStatus || '').toUpperCase());

    if (needsB2bCheck) {
      this.util.startLoader();
      const userId = localStorage.getItem('userId') || '';
      let viewerBusinessId = '';
      try {
        const roleRes: any = await this.apiService.query(`business/findUserRoleInBusiness/${userId}`).toPromise();
        viewerBusinessId = roleRes?.data?.businessData?.businessId || '';
      } catch (e) {
        viewerBusinessId = '';
      }

      try {
        const b2bRes: any = await this.contractCandidateService
          .validateB2bConnection(viewerBusinessId, data.jobId, data.candidateId, data.currentStatus)
          .toPromise();
        if (b2bRes?.code === '10005') {
          this.util.stopLoader();
          Swal.fire({
            icon: 'warning',
            title: 'Organization Required',
            html: b2bRes.message || 'Corp-to-Corp candidates must have an active organization.',
            confirmButtonText: 'OK',
            showCancelButton: false
          });
          return;
        } else if (b2bRes?.code === '10002' || b2bRes?.code === '10003' || b2bRes?.code === '10004') {
          // 10004 = invite already pending acceptance → popup only, no route.
          // showNoB2bPopup handles the 10004 messaging + suppresses the navigation CTA.
          this.util.stopLoader();
          const result = await this.contractCandidateService.showNoB2bPopup(b2bRes.code, b2bRes.message);
          if (result.isConfirmed && b2bRes.code === '10002') {
            // Offer-Accept is the SUPPLIER-side action (candidate owner accepting) — they need to
            // connect with the CUSTOMER (job owner). Route to Business Contacts with the customer
            // pre-filled so the Add Business form auto-opens, mirroring job-card.jobupdatestatus /
            // the Applicant page. (This is the Accept-Offer path — NOT Initiate Contract, which
            // pre-fills the SUPPLIER.)
            const customerId = b2bRes?.data?.customerBusinessId || '';
            const customerName = b2bRes?.data?.customerBusinessName || '';
            this.router.navigate(['/user-management/businessContacts'], {
              queryParams: {
                customerBusinessId: customerId,
                customerBusinessName: customerName
              }
            });
          }
          return;
        } else if (b2bRes?.code === '99996') {
          // Mandatory-document gate (ContractCandidateService validate-b2b-connection).
          // Own popup so the user sees the next action instead of a generic
          // "Validation Failed" + the raw backend sentence.
          this.util.stopLoader();
          await this.contractCandidateService.showMandatoryDocumentPopup();
          return;
        } else if (b2bRes?.code !== '00000') {
          this.util.stopLoader();
          Swal.fire({
            icon: 'error',
            title: 'Validation Failed',
            text: b2bRes?.message || 'Unable to proceed with this status change.'
          });
          return;
        }
        this.util.stopLoader();
      } catch (e) {
        this.util.stopLoader();
      }
    }

    try {
      this.util.startLoader();
      const res = await this.apiService.create("candidates/updatejobAppliedStatus", data).toPromise();
      this.util.stopLoader();
      if (res.code === "00000") {
        this.candidateval.currentStatus = data.currentStatus;

        Swal.fire({
          position: "center",
          icon: "success",
          title: "Status successfully Updated.",
          showConfirmButton: false,
          timer: 2000,
        });

        // Non-Corp-to-Corp absorption: freeze other applications at OFFER-ACCEPTED
        const engType = this.candidateval?.engagementType;
        const isNonCorpToCorp = engType && engType !== 'Corp to Corp' && engType !== 'Corp To Corp';

        if (data.currentStatus === 'OFFER-ACCEPTED' && isNonCorpToCorp && data.candidateId) {
          this.contractCandidateService.freezeOtherApplications(data.candidateId, data.jobId).subscribe({
            next: (freezeRes: any) => {
              if (freezeRes.code === '00000' && freezeRes.data?.frozenCount > 0) {
                Swal.fire({
                  icon: 'info',
                  title: 'Applications Frozen',
                  html: `<strong>${freezeRes.data.frozenCount}</strong> other application(s) have been frozen while this offer is pending.`,
                  showConfirmButton: true,
                  confirmButtonText: 'OK'
                });
              }
            },
            error: () => { /* Non-blocking — backend will handle independently */ }
          });
        }

        // Non-Corp-to-Corp absorption: invalidate other applications at ONBOARDED
        if (data.currentStatus === 'ONBOARDED' && isNonCorpToCorp && data.candidateId) {
          this.contractCandidateService.invalidateOtherApplications(data.candidateId, data.jobId).subscribe({
            next: (invRes: any) => {
              if (invRes.code === '00000' && invRes.data?.invalidatedCount > 0) {
                Swal.fire({
                  icon: 'info',
                  title: 'Candidate Absorbed',
                  html: `This candidate has been onboarded. <strong>${invRes.data.invalidatedCount}</strong> other application(s) have been automatically closed and notifications sent.`,
                  showConfirmButton: true,
                  confirmButtonText: 'OK'
                });
              }
            },
            error: () => { /* Non-blocking */ }
          });
        }

        data.eachCandidate = true;
        this.searchData.setJobID(data);
        //activitydate set for api response by monisha
        const appliedCandidate = res.data.jobData.appliedBy.find(candidate => candidate.userId === data.candidateId);
        data.activityDate = appliedCandidate ? appliedCandidate.date : null;
        data.isSelected = true;
        this.jobapp_to_newjob_to_atvity.emit(data);
        if(candidate){
          this.statusUpdated.emit(candidate);
        }

      }else if (res.code == "99998") {
        Swal.fire({
          position: "center",
          icon: "info",
          title: "Job application status updated already..!",
          showConfirmButton: true,
          allowEscapeKey: false,
          allowOutsideClick: false,
        }).then((result) => {
          if (result.isConfirmed) {
            this.JobServicecolor.confirmResult();
          }
        });
      }else if(res.code =='99996'){
        // Same mandatory-document gate as validate-b2b-connection above — one
        // wording for both paths so the user never sees two different sentences
        // for the same blocker.
        this.contractCandidateService.showMandatoryDocumentPopup();
      }
    } catch (err) {
      this.util.stopLoader();

    }
  }




  // Inherited from FormValidation - uses APPLICANT_STATUS_COLOR array
  // getStyle(status: APPLICANT_STATUS) {
  //   const find = this.APPLICANT_STATUS_COLOR.find(p => p.key === status);
  //   return find ? { color: find.color, background: find.background } : { border: '', color: '', background: '' };
  // }

  // Candidate availability wording. A candidate's ACTIVE/INACTIVE record state
  // is shown to users as Available/Unavailable everywhere else in the product
  // (candidates-page.component.html:596-609,
  // candidate-profile-summary.component.html:261-262) — the raw
  // convertSmallCase() output ('Active'/'Inactive') was the odd one out on the
  // Talent Center / Talent Pool rows. DRAFTED and BLOCKED keep their own words.
  getCandidateStatusLabel(status: string): string {
    switch (status) {
      case 'ACTIVE': return 'Available';
      case 'INACTIVE': return 'Unavailable';
      case 'DRAFTED': return 'Draft';
      case 'BLOCKED': return 'Blocked';
      default: return this.formatStatusLabel(status);
    }
  }

  getFilterValue(key: string, content: string = "JOB_APPLICANT") {
    if (this.filterApplicantData) {
      const arrs: Array<any> = content === "JOB_APPLICANT" ? [...this.filterApplicantData.JOB_APPLICATION_BUYER_ACTIONS.listItems] :
        [...this.filterApplicantData.JOB_INVITATION_SUPPLIER_ACTIONS.listItems];
      if (arrs) {
        const find = arrs.find(c => c.itemId === key);
        // Statuses absent from the backend master list (e.g. L1/L2/L3
        // INTERVIEW) used to render a blank pill — fall back to the
        // normalized raw status ('L1-INTERVIEW' → 'L1 Interview').
        return find ? find.value : this.formatStatusLabel(key);
      }
    }
  }

  // ---- Contract-row-v3 context-aware status dropdown methods ----

  contractFilterApplicant(data: any, nextAllowedStatuses?: string[]): any[] {
    // Buyer path: reuse the standard ladder (carries the role filter).
    if (this.contractContext !== 'customer') {
      return this.filterApplicant(data, nextAllowedStatuses);
    }

    // Supplier path: use JOB_APPLICATION_SUPPLIER_ACTIONS (job-card style logic)
    if (!this.filterApplicantData?.JOB_APPLICATION_SUPPLIER_ACTIONS?.listItems) return [];

    const arrs = [...this.filterApplicantData.JOB_APPLICATION_SUPPLIER_ACTIONS.listItems];
    const found = arrs.find((_x: any) => _x.itemId === data);
    if (!found) return [];
    const order = found.order;

    const finalData = arrs.reduce((acc: Array<any>, current: any, index: number, arr: any[]) => {
      const find = acc.find((_d: any) => _d.itemId === current.itemId);
      const next = arr.indexOf(current) + 1;
      if (find === undefined) {
        const nextData = arr[next];
        if (nextData && (current.item === undefined || current.item === null) && data === current.itemId) {
          if (nextData.item != undefined || nextData.item != null) {
            acc.push(...arr.filter((c: any) => c.order === order + 1));
            return acc;
          }
        }
        if ((current.order === undefined || current.order === null) && current.item != undefined) {
          acc.push(current);
        }
      }
      return acc;
    }, []);

    return finalData;
  }

  getTrackingStatusLabel(status: string): string {
    const labels: Record<string, string> = {
      'NOT_INITIATED': 'Not Initiated',
      'CONTRACT_INITIATED': 'Contract Initiated',
      'CONTRACT_IN_PROGRESS': 'Contract In Progress',
      'CONTRACT_COMPLETED': 'Contract Completed',
      'SUPPLIER_SIGNED': 'Supplier Signed',
      'CUSTOMER_SIGNED': 'Customer Signed',
      'WORKORDER_INITIATED': 'WO Initiated',
      'WORKORDER_SIGNED': 'WO Signed'
    };
    return labels[status] || status?.replace(/[_-]/g, ' ').replace(/\b\w/g, c => c.toUpperCase()) || 'Not Initiated';
  }

  getTrackingStatusClass(status: string): string {
    const classes: Record<string, string> = {
      'NOT_INITIATED': 'tracking-not-initiated',
      'CONTRACT_INITIATED': 'tracking-contract-initiated',
      'CONTRACT_IN_PROGRESS': 'tracking-contract-in-progress',
      'CONTRACT_COMPLETED': 'tracking-contract-completed',
      'SUPPLIER_SIGNED': 'tracking-supplier-signed',
      'CUSTOMER_SIGNED': 'tracking-customer-signed',
      'WORKORDER_INITIATED': 'tracking-wo-initiated',
      'WORKORDER_SIGNED': 'tracking-wo-signed'
    };
    return classes[status] || 'tracking-not-initiated';
  }

  contractGetFilterValue(key: string): string | null {
    if (!this.filterApplicantData) return null;

    const supplierItems = this.filterApplicantData.JOB_APPLICATION_SUPPLIER_ACTIONS?.listItems || [];
    const buyerItems = this.filterApplicantData.JOB_APPLICATION_BUYER_ACTIONS?.listItems || [];

    if (this.contractContext === 'customer') {
      // Try supplier actions first, fallback to buyer actions, then getFilterValue
      const find = supplierItems.find((c: any) => c.itemId === key);
      if (find) return find.value;
      const fallback = buyerItems.find((c: any) => c.itemId === key);
      if (fallback) return fallback.value;
      return this.getFilterValue(key);
    }

    // Try buyer actions first, fallback to supplier actions, then getFilterValue
    const find = buyerItems.find((c: any) => c.itemId === key);
    if (find) return find.value;
    const fallback = supplierItems.find((c: any) => c.itemId === key);
    if (fallback) return fallback.value;
    return this.getFilterValue(key);
  }

  isContractStatusEnabled(): boolean {
    const myBusinessId = localStorage.getItem('myBusinessId') || '';
    const supplierBusinessId = this.candidateval?.contractData?.supplierBusinessId || '';
    if (supplierBusinessId === myBusinessId) {
      return this.candidateval?.candidateBusinessId === myBusinessId;
    } else {
      return this.candidateval?.jobOwnerBusinessId === myBusinessId;
    }
  }

  contractUpdateStatus(statusData: any, candidateVal: any): void {
    // Supplier path: validateNegativeStatus shows confirmation for negative statuses
    this.validateNegativeStatus(statusData, candidateVal);
    // if (this.contractContext === 'customer') {
    // } else {
    //   // Buyer path: direct update (existing behavior)
    //   this.updatestatus(statusData, candidateVal);
    // }
  }

  chatuser(seletedItem: any, connectionModal?: TemplateRef<any>) {

    this.candidateData = seletedItem;
    this.focus = 'candidate';
    if (seletedItem.createdBy == this.userId) {
      this.openMessage(seletedItem)
    }
    this.checkConnectionStatus(seletedItem)
      .subscribe(response => {
        if (seletedItem.isFeatured != undefined && seletedItem.isFeatured == true) {
          this.openMessage(seletedItem)
        } else if (seletedItem.isFeatured == false || seletedItem.isFeatured == undefined && seletedItem.createdBy != this.userId) {
          //if (response.data.connectionStatus === 'CONNECTED') {
            this.openMessage(seletedItem);
          //} else if (response.data.connectionStatus !== 'CONNECTED') {
           // this.openMessage(seletedItem);
            // to be used later
            // this.openConnectionTemplate(response.data.connectionStatus, seletedItem, connectionModal);
          //}
        }
      })
  }
  async openMessagecheckInteraction(seletedItem, connectionTemplate?: TemplateRef<any>) {
    // For contract-row-v3, the list API returns a slim candidate object without createdBy.
    // Fetch full candidate data first so chat can resolve the target user.
    if (this.viewSize === 'contract-row-v3' && !seletedItem.createdBy) {
      const candidateId = seletedItem?.candidateId;
      if (!candidateId) return;
      this.util.startLoader();
      this.apiService.query('candidates/findCandidateById/' + candidateId).subscribe(
        (res: any) => {
          this.util.stopLoader();
          if (res?.code === '00000' && res?.data?.candidateData) {
            const full = res.data.candidateData;
            seletedItem.createdBy = full.createdBy;
            seletedItem.chatHistoryCount = full.chatHistoryCount || 0;
            seletedItem.nonSeenMessageCount = full.nonSeenMessageCount || 0;
            seletedItem.connectionStatus = full.connectionStatus;
            seletedItem.isFeatured = full.isFeatured;
            this._openMessageAfterPlanCheck(seletedItem, connectionTemplate);
          }
        },
        () => { this.util.stopLoader(); }
      );
      return;
    }
    this._openMessageAfterPlanCheck(seletedItem, connectionTemplate);
  }

  private async _openMessageAfterPlanCheck(seletedItem, connectionTemplate?: TemplateRef<any>) {
    // Universal first-interaction: call message/contact/exist first; if a contact
    // already exists (or a prior invite / resume-request already consumed this pair),
    // open the chat directly and skip the ACTIVE_INTERACTIONS gate
    // (findUserPlanBenefits / findPlans). Otherwise gate as before. Fails safe.
    // Owner's rule (2026-09-09): one credit is consumed only when a chat is
    // first initiated, so every menu follows this exist-first order.
    if (await this.planService.isInteractionAlreadyConsumed(seletedItem?.candidateId, 'CANDIDATE')) {
      this.chatuser(seletedItem);
      return;
    }
    try {
      this.util.startLoader();
      const userData = await this.planService.UPDATE_USERDETAILS("ACTIVE_INTERACTIONS");
      let { userDetail, isExpired, membershipType } = userData;
      let availablePoints = null;
      let actualPoints = null;
      let utilizedPoints = null;
      let promotional = null;
      if (userDetail && userDetail.userPlanAndBenefits && userDetail.userPlanAndBenefits.benefitsUsages) {
        userDetail.userPlanAndBenefits.benefitsUsages.forEach(ele => {
          if (ele.benefitKey == 'ACTIVE_INTERACTIONS') {
            availablePoints = ele.available;
            actualPoints = ele.actual;
            utilizedPoints = ele.utilized;
            promotional = ele.promotional;
          }
        });
      } else {
        this.util.startLoader();
        this.chatuser(seletedItem);

        return;
      }

      if (isExpired) {
        let popupType: "PAY" | "LIMIT" | "UPGRADE" = "PAY";

        if (['Starter','Growth','ScaleX'].includes(membershipType)) {
          popupType = "LIMIT";
        }

        this.planService.expiredPopup("ACTIVE_INTERACTIONS", popupType, null, null, null,null, availablePoints, actualPoints, utilizedPoints, promotional);

      } else {
        this.util.startLoader();
        this.chatuser(seletedItem);

      }
    } catch (error) {
    } finally {
      setTimeout(() => {
        this.util.stopLoader();
      },1500);
    }

  }

  openMessage(seletedItem) {
    this.messagemodelflag = false;
    // this._socket.ngOnDestroy();
    // this._socket.connections();

    if (seletedItem.createdBy == this.userId) {
      seletedItem.owner = true;
    } else {
      seletedItem.owner = false;
    }

    setTimeout(() => {
      // if (this.userId != seletedItem.createdBy) {
      seletedItem.userId = seletedItem.createdBy;
      this.seletedChatItem = seletedItem;
      this.messageData = [];
      this.messagemodelflag = true;
      seletedItem.groupType = "CANDIDATE";
      seletedItem.messageType = "CANDIDATE";
      seletedItem.id = seletedItem.candidateId;
      this.messageData = seletedItem;
      // }
    }, 1000);
  }

  closeMessage(event) {
    this.messagemodelflag = false;
    // this._socket.ngOnDestroy();
  }

  // Timeline properties (same as candidate-activity-widget)
  timelineIsLoading = false;
  jeas: any = [];
  payload: any = {};
  displayingdata: any;
  mergedTimelineData: any[] = [];
  
  // Timeline filter data (from timeline component)
  filterStatusData: Array<any>;
  jobApplicationListValues: any[] = []
  jobApplicationFutureListValues: any[] = []
  blockingListValues: any[] = []
  activityEnded: boolean = false;
  
  // Timeline methods - copied from candidate-activity-widget
  loadTimelineData() {   
    this.prepareTimelinePayload();
    this.getJobActivities();
  }
  
  prepareTimelinePayload() {
    // Initialize payload exactly like candidate-activity-widget
    this.payload = {
      entityId: this.appliedJobDetails?.jobId, // Use jobId as entityId, not candidateId
      entityType: "JOB",
      limit: 20,
      searchAfterKey: null,
      activityOn: this.candidateval?.candidateId, // candidateId goes in activityOn
      parentActivity: "JOB_APPLICATION,CANDIDATE_INVITATION"
    };
    
    // Set owner flag like in candidate-activity-widget
    if (this.appliedJobDetails?.jobPostedBy == this.userId) {
      this.payload.owner = true;
    } else {
      this.payload.owner = false;
    }
    
    console.log('Timeline payload:', this.payload);
  }
  
  getJobActivities() {
    if (this.appliedJobDetails && this.appliedJobDetails.jobId !== undefined) {
      this.timelineIsLoading = true;
      this.apiService.create("jobs/findTimeLines", this.payload).subscribe(res => {
        console.log('Timeline API response:', res);
        if (res && res.code === "00000" && res.data) {
          this.displayingdata = res.data;
          this.handleTimelineResponse(res.data);
        } else {
          this.timelineIsLoading = false;
          this.jeas = [];
        }
      }, err => {
        console.error('Timeline API error:', err);
        this.timelineIsLoading = false;
        this.jeas = [];
      });
    }
  }
  
  handleTimelineResponse(data) {
    if (data && data.timeLines) {
      this.updateJeas(data.timeLines);
      // After updating jeas, get the filter data and process timeline for display
      this.getAppliedFilter();
    } else {
      this.timelineIsLoading = false;
      this.jeas = [];
      this.mergedTimelineData = [];
    }
  }
  
  updateJeas(timeLines) {
    this.jeas = [];
    timeLines.forEach(ele => {
      if(ele.activityType == "SHORTLISTED") {
        ele.activityType = "CANDIDATE-SHORTLISTED"
      }
      if(ele.entityType=="CANDIDATE"){
        ele.entityId = ele.candidateReferenceId
      }else{
        ele.entityId= ele.jobReferenceId
      }
      this.jeas.push(ele);
    });
    
    // Remove duplicates
    this.jeas = this.jeas.filter((obj, pos, arr) => {
      return arr.map(mapObj => mapObj.activityId).indexOf(obj.activityId) === pos;
    });
    
    console.log('Timeline events processed:', this.jeas);
  }
  
  // Timeline filter processing (copied from timeline component)
  getAppliedFilter() {
    this.apiService.create('listvalue/findbyList', { domain: "TIMELINE_ACTIVITY_VALUES,JOB_APPLICATION_ACTIVITY,BLOCKING_ACTIVITY_LIST" }).subscribe(res => {
      const sorted: Array<any> = res.data.TIMELINE_ACTIVITY_VALUES && res.data.TIMELINE_ACTIVITY_VALUES.listItems;
      this.blockingListValues = res.data.BLOCKING_ACTIVITY_LIST.listItems
      this.filterStatusData = res.data;
      if (sorted) {
        this.filterStatusData = sorted.map(x => {
          return { itemId: x.itemId, value: x.value };
        });
      }

      let jobApplicationListValues: any[] = []
      jobApplicationListValues = res.data.JOB_APPLICATION_ACTIVITY.listItems
      if (Array.isArray(jobApplicationListValues) && jobApplicationListValues.length > 0) {
        let recentActivity: any;
        let recentActivityOrder: any;
        if (this.jeas) {
          recentActivity = this.jeas[0]
        }

        if (recentActivity) {
          recentActivityOrder = jobApplicationListValues.find(ele => ele.itemId === recentActivity.activityType)
        }

        if (recentActivityOrder) {
          this.jobApplicationFutureListValues = []
          jobApplicationListValues.forEach(ele => {
            if (ele.order > recentActivityOrder.order) {
              this.jobApplicationFutureListValues.push(ele);
            }
          })
        }

        const filteredData: any = [];
        const encounteredData = new Set<number>();

        for (const item of this.jobApplicationFutureListValues) {
          if (!encounteredData.has(item.order)) {
            filteredData.push(item);
            encounteredData.add(item.order);
          }
        }

        this.jobApplicationListValues = filteredData.map(x => {
          return { itemId: x.itemId, value: x.value, item: x.item, order: x.order }
        })

        // Process events to set notion (positive/negative/progress)
        for (const item of this.jeas) {
          const exists = this.blockingListValues.find((listItem) => (listItem.itemId === item.activityType));
          if (exists) {
            item.notion = "negative"
          } else {
            item.notion = "positive"
          }
        }

        if (this.jeas[0] && this.jeas[0].activityType == "ONBOARDED") {
          this.jeas[0].notion = "positive"
          this.activityEnded = true
        } else {
          if (this.jeas[0] && this.jeas[0].notion != "negative") {
            this.jeas[0].notion = "progress"
            this.activityEnded = false
          } else if (this.jeas[0] && this.jeas[0].notion == "negative") {
            this.activityEnded = true
          }
        }
      }
      
      // Now process the timeline data for horizontal display
      this.processTimelineForHorizontalDisplay();
    });
  }
  
  processTimelineForHorizontalDisplay() {
    this.mergedTimelineData = [];
    
    // Process existing timeline events (reverse order since jeas comes newest first)
    const reversedJeas = [...this.jeas].reverse();
    reversedJeas.forEach((event, index) => {
      this.mergedTimelineData.push({
        title: this.getTimelineFilterValue(event.activityType) || event.activityType,
        createdOn: event.createdOn,
        notion: event.notion,
        showIcon: true,
        showDate: true,
        showNumber: false,
        order: index
      });
    });
    
    // Check if the most recent activity (first in jeas array) has negative notion
    const hasNegativeNotion = this.jeas.length > 0 && this.jeas[0].notion === "negative";
    
    // Only add future activities if the current notion is not negative
    if (!hasNegativeNotion) {
      const sortedFutureActivities = [...this.jobApplicationListValues].sort((a, b) => a.order - b.order);
      sortedFutureActivities.forEach((futureActivity, index) => {
        this.mergedTimelineData.push({
          title: futureActivity.value || futureActivity.item,
          notion: "future",
          showIcon: false,
          showDate: false,
          showNumber: true,
          order: reversedJeas.length + index
        });
      });
    }
    
    console.log('Processed timeline data:', this.mergedTimelineData, 'Has negative notion:', hasNegativeNotion);
    
    this.timelineIsLoading = false;

  }
  
  getTimelineFilterValue(key: string) {
    if (Array.isArray(this.filterStatusData)) {
      const arrs: Array<any> = [...this.filterStatusData];
      if (arrs) {
        const find = arrs.find(c => c.itemId === key);
        return find ? find.value : null;
      }
    }
    return null;
  }

  ngOnChanges() {
    // Check for current organization whenever candidateval changes
    this.checkCurrentOrganization();

    // Load timeline for medium view
    if (this.viewSize === 'medium' && (this.candidateval?.candidateId || this.appliedJobDetails?.jobId)) {
      this.loadTimelineDataForAPI();
    }

    // Load timeline for row-design view
    if (this.viewSize === 'row-design' && this.showTimeline && this.candidateval?.candidateId) {
      console.log('[CandidateCard] Row-design timeline reload triggered');
      this.loadTimelineDataForAPI();
    }

    // Initialize showAllSkills for row-design view
    if (this.viewSize === 'row-design' && this.candidateval) {
      if (this.candidateval.showAllSkills === undefined) {
        this.candidateval.showAllSkills = false;
      }
    }

    // Initialize skillsExpanded for large view
    if (this.viewSize === 'large' && this.candidateval) {
      if (this.candidateval.skillsExpanded === undefined) {
        this.candidateval.skillsExpanded = false;
      }
    }
  }

  // Load timeline data for the candidate via API
  private async loadTimelineDataForAPI(): Promise<void> {
    if (!this.candidateval?.candidateId) return;
    
    try {
      const jobId = this.appliedJobDetails?.jobId || this.passValues?.jobId;
      await this.fetchTimelineData(this.candidateval.candidateId, jobId);
    } catch (error) {
      console.error('Error loading timeline data:', error);
    }
  }

 

sendMessage(candidate: any) {
  // Implement messaging logic
  console.log('Sending message to:', candidate.firstName);
}

toggleFavorite(candidate: any) {
  // Implement favorite toggle logic
  console.log('Toggling favorite for:', candidate.firstName);
}

  typeOfDocuments = [
    {name: 'Resume', mandatory: false, isUploaded: true, 
      documents:[
        // {name: 'New Resume',lastUpdated: '28/09/2025',validFrom : '', expiry:'', status: 'Verified', attachment:''},
      ],
      headers : []
    },
    {name: 'Drivers License', mandatory: false, isUploaded: true, 
      documents:[
        // {name: 'License',lastUpdated: '28/09/2025',validFrom : '25/08/2003', expiry:'16/08/2023', status: 'Expired', attachment:''},
        // {name: 'License',lastUpdated: '28/09/2025',validFrom : '13/04/2024', expiry:'19/12/2035', status: 'Pending Verification', attachment:''},
      ]
    },
    {name: 'Employment Authorization Document', mandatory: false, isUploaded: false,documents:[]},
    {name: 'Passport', mandatory: false, isUploaded: false,documents:[]},
    {name: 'Visa', mandatory: false, isUploaded: false,documents:[]},
    {name: 'I-94', mandatory: false, isUploaded: false,documents:[]},
    {name: 'Background Check Certification', mandatory: false, isUploaded: false,documents:[]},
    {name: 'Background Verification', mandatory: false, isUploaded: false,documents:[]},
    {name: 'Drug Screening', mandatory: false, isUploaded: false,documents:[]}
  ];
  
  openDocuments() {
    // Clear any documents from a previous open BEFORE (re)rendering the slider.
    // getSavedRequiredDocuments() repopulates `typeOfDocuments` in place
    // asynchronously and bails via `if (!config) return` when there's no saved
    // config — without this reset the slider can surface stale rows that don't
    // belong to the current open.
    this.resetTypeOfDocuments();
    if (this.pageName === 'contract-candidates' && this.contractContext === 'customer') {
      // Supplier side: check if job owner has initiated document collection first
      this.getSavedRequiredDocuments('open');
    } else {
      this.getSavedRequiredDocuments();
      this.showDocumentSection = true;
    }
  }

  /** Blank out the shared document buckets + header counts so the slider
   *  starts clean each time it is opened. */
  resetTypeOfDocuments() {
    for (const doc of this.typeOfDocuments) {
      doc.mandatory = false;
      doc.documents = [];
    }
    this.totalMandatoryDocuments = 0;
    this.allVerified = false;
  }

  closeDocuments() {
    this.showDocumentSection = false;
    this.documentsClosed.emit();
  }

  openPayRate(candidateval: any, template: TemplateRef<any>) {
    this.validateB2bAndOpenPayrate(null, candidateval, template);
  }

  refreshDocumentData() {
    // Call existing method to fetch fresh data
    this.getSavedRequiredDocuments();
  }

  documentsRequired ={
    "jobId":'',
    "candidateId": '',
    "resumeMandatory": '',
    "driversLicenseMandatory": '',
    "employmentAuthorizationMandatory": '',
    "passportMandatory": '',
    "visaMandatory": '',
    "i94Mandatory": '',
    "backgroundCheckstatusMandatory": '',
    "backgroundCheckCertificateMandatory": '',
    "drugScreenMandatory": '',
    "conversationKey":"SENDER"
  }

  saveDocuments(value:any) {
    console.log('list of documents  ;:: ', value);
    this.documentsRequired.jobId = this.jobId || this.currentJobId || this.candidateval?.contractData?.jobId || this.appliedJobDetails?.jobId;
    this.documentsRequired.candidateId = this.candidateval.candidateId;
    
    this.documentsRequired.resumeMandatory = value.find(e => e.name === 'Resume')?.mandatory ?? false;
    this.documentsRequired.driversLicenseMandatory = value.find(e => e.name === 'Drivers License')?.mandatory ?? false;
    this.documentsRequired.employmentAuthorizationMandatory = value.find(e => e.name === 'Employment Authorization Document')?.mandatory ?? false;
    this.documentsRequired.passportMandatory = value.find(e => e.name === 'Passport')?.mandatory ?? false;
    this.documentsRequired.visaMandatory = value.find(e => e.name === 'Visa')?.mandatory ?? false;
    this.documentsRequired.i94Mandatory = value.find(e => e.name === 'I-94')?.mandatory ?? false;
    this.documentsRequired.backgroundCheckstatusMandatory = value.find(e => e.name === 'Background Verification')?.mandatory ?? false;
    this.documentsRequired.backgroundCheckCertificateMandatory = value.find(e => e.name === 'Background Check Certification')?.mandatory ?? false;
    this.documentsRequired.drugScreenMandatory = value.find(e => e.name === 'Drug Screening')?.mandatory ?? false;

    console.log('documents required :: ', this.documentsRequired);

    this.util.startLoader();
    this.apiService.create('jobs/requestMandatoryDocuments', this.documentsRequired)
    .pipe(
      finalize(() => this.util.stopLoader()) // always stop loader
    )
    .subscribe({
      next: (res: any) => {
        console.log('res ', res);
        if (res.code === '00000') {
          this.showDocumentSection = false;
          this.documentsClosed.emit();
          Swal.fire({
            title: 'Required documents updated successfully',
            icon: 'success',
            showConfirmButton: false,
            timer: 2000   // auto close after 2 seconds
          });
        } else {
          Swal.fire('', res?.message || 'Something went wrong', 'error');
        }
      },
      error: (err) => {
        console.error(err);
        Swal.fire('Something went wrong', '', 'error');
      }
    });     
  }

  totalMandatoryDocuments:any;
  allVerified:any;
  getSavedRequiredDocuments(from?: string) {
    // Use jobId from multiple sources: this.jobId, currentJobId, contractData, or jobDetails.jobId
    const jobId = this.jobId || this.currentJobId || this.candidateval?.contractData?.jobId || this.appliedJobDetails?.jobId;

    // Don't make the API call if we don't have both jobId and candidateId
    if (!jobId || !this.candidateval?.candidateId) {
      console.warn('[CandidateCard] getSavedRequiredDocuments - Missing jobId or candidateId', {
        jobId: jobId,
        candidateId: this.candidateval?.candidateId
      });
      return;
    }

    let payload = {
      jobId: jobId,
      candidateId: this.candidateval.candidateId
    };

    this.util.startLoader();
    this.apiService.create('jobs/getContractDocumentDetails', payload)
      .pipe(finalize(() => this.util.stopLoader()))
      .subscribe({
        next: (res: any) => {
          console.log('details , ', res);
          const config = res.data?.existingConfig;

          if (!config) {
            if (from === 'open') {
              Swal.fire('The requestor has not initiated document collection process. You will be notified once it is initiated.', '', 'info');
            }
            return;
          }

          if (from === 'open' && !this.showDocumentSection) {
            this.showDocumentSection = true;
          }

          // Map API response to typeOfDocuments
          for (let doc of this.typeOfDocuments) {
            switch (doc.name) {
              case 'Resume':
                doc.mandatory = config.resumeMandatory;
                doc.documents = config?.resumeDocuments || [];
                break;
              case 'Drivers License':
                doc.mandatory = config.driversLicenseMandatory;
                doc.documents = config?.driversLicenseDocuments || [];
                break;
              case 'Employment Authorization Document':
                doc.mandatory = config.employmentAuthorizationMandatory;
                doc.documents = config?.employmentAuthorizationDocuments || [];
                break;
              case 'Passport':
                doc.mandatory = config.passportMandatory;
                doc.documents = config?.passportDocuments || [];
                break;
              case 'Visa':
                doc.mandatory = config.visaMandatory;
                doc.documents = config?.visaDocuments || [];
                break;
              case 'I-94':
                doc.mandatory = config.i94Mandatory;
                doc.documents = config?.i94Documents || [];
                break;
              case 'Background Verification':
                doc.mandatory = config.backgroundCheckstatusMandatory;
                doc.documents = config?.backgroundCheckDocuments || [];
                break;
              case 'Background Check Certification':
                doc.mandatory = config.backgroundCheckCertificateMandatory;
                doc.documents = config?.backgroundCheckCertificationDocuments || [];
                break;
              case 'Drug Screening':
                doc.mandatory = config.drugScreenMandatory;
                doc.documents = config?.drugScreenDocuments || [];
                break;
            }
          }
          // Read the verified state + counts from existingConfig (authoritative). The
          // documentProgress map uses the key "allVerified" (NOT "allMandatoryVerified") and does
          // NOT carry totalVerifiedCount, so the previous reads were always undefined — after every
          // mandatory document was verified the badge wrongly showed "0 / Action required" instead
          // of "<verified count> / All verified", making the verified document look missing.
          const allVerified = config?.allMandatoryVerified === true;
          this.totalMandatoryDocuments = allVerified
            ? (config?.totalVerifiedCount ?? 0)
            : (config?.headerCount ?? 0);

          this.allVerified = allVerified;

          console.log('Updated typeOfDocuments :: ', this.typeOfDocuments);
        },
        error: (err: any) => {
          console.error('Error fetching document details', err);
        }
      });
  }

  showPercentageDetails: boolean = false;
  details:any;
  openPercentageDetails(item:any){
    this.showPercentageDetails = true;
    // Ensure we pass organisationId from localStorage or jobDetails
    this.details = {
      ...item,
      organisationId: item.organisationId || localStorage.getItem('organisationId') || this.appliedJobDetails?.organisationId
    };
  }

  closePercentageDetails(){
    this.showPercentageDetails= false;
    this.details = null;
  }

  /** Share the candidate via a login-bridge URL — mirrors the SSR pattern
   *  (job-listing.component.ts:35-43 `getCandidateParams`). Same URL works
   *  for logged-in and logged-out recipients: AfterLoginGuard bounces authed
   *  users past login; unauthed users go through login and land on the
   *  correct candidate page via login.component's absolutePath+data branch. */
  shareProfile(item: any): void {
    const candidateId = item?.candidateId;
    if (!candidateId) return;
    const data = {
      candidateId,
      tabName: 'profileSummary',
      From: 'CANDIDATES_FROM_CONNECTION'
    };
    const url = `${window.location.origin}/#/auth/login`
              + `?redirectTo=/newcandidates`
              + `&absolutePath=true`
              + `&data=${encodeURIComponent(JSON.stringify(data))}`;
    const name = ((item?.firstName || '') + ' ' + (item?.lastName || '')).trim()
              || item?.fullName || item?.fullname || 'Candidate';
    const nav: any = window.navigator;
    if (nav?.share) {
      nav.share({ title: name, url }).catch(() => { /* user cancelled */ });
    } else if (nav?.clipboard) {
      nav.clipboard.writeText(url);
    }
  }

  scheduleInterview(item: any): void {
  }

  addNotes(item: any): void {
  }

  /**
   * Initialize Work Order - emits event for contract-candidates page
   */
  onInitializeWorkOrderClick(): void {
    if (!this.initiateContractEnabled) return;
    // Initiate Contract is a customer-only action. The icon is shown to both sides as a
    // progress tick, but only the customer (contractContext === 'supplier') may trigger it.
    if (this.contractContext !== 'supplier') return;
    this.initializeWorkOrder.emit(this.candidateval);
  }

  onSignContractClick(): void {
    if (!this.signContractEnabled) return;
    this.signContract.emit(this.candidateval);
  }

  /**
   * Release Work Order - emits event when all pre-conditions are met (canInitiate = true)
   */
  onReleaseWorkOrderClick(): void {
    if (!this.initiateWOEnabled) return;
    // Initiate Work Order is a customer-only action (progress tick visible to both sides).
    if (this.contractContext !== 'supplier') return;
    this.releaseWorkOrder.emit(this.candidateval);
  }


  // ============================================================
  // TIMELINE PROCESSING METHODS (Copied from job-applicants)
  // ============================================================

  // Process timeline events for a candidate - COMPLETELY REWRITTEN
  processTimelineForCandidate(candidate: any) {
    if (!candidate.timelineEvents || candidate.timelineEvents.length === 0) {
      candidate.timelineDates = {};
      candidate.mergedTimelineData = [];
      candidate.timelineStages = this.getDefaultTimelineStages();
      return;
    }

    console.log('🔍 [CandidateCard] Processing timeline for candidate:', candidate.candidateId);
    console.log('📋 Raw timeline events:', candidate.timelineEvents);
    console.log('📋 Job application order list:', this.jobApplicationListValues);

    // STEP 1: Order all timeline events based on the JOB_APPLICATION_ACTIVITY order from API
    const orderedEvents = this.orderTimelineEventsByAPI(candidate.timelineEvents);
    console.log('✅ Ordered events:', orderedEvents);

    // STEP 2: Group events into stages and identify rejection points
    const groupedStages = this.groupEventsIntoStages(orderedEvents);
    console.log('✅ Grouped stages:', groupedStages);

    // STEP 3: Build timeline stages with rejection handling
    candidate.timelineStages = this.buildTimelineStagesFromGroupedEvents(groupedStages);
    console.log('✅ Final timeline stages:', candidate.timelineStages);

    // Set legacy date properties for backward compatibility
    candidate.timelineDates = {};
    candidate.timelineStages.forEach((stage: any) => {
      if (stage.date) {
        candidate.timelineDates[stage.id] = stage.date;
      }
    });

    console.log('🎯 Timeline processing complete for:', candidate.candidateId);
  }

  // STEP 1: Order timeline events by JOB_APPLICATION_ACTIVITY API order
  orderTimelineEventsByAPI(events: any[]): any[] {
    if (!this.jobApplicationListValues || this.jobApplicationListValues.length === 0) {
      console.warn('⚠️ No jobApplicationListValues available, returning events as-is');
      return events;
    }

    // Create a map of activityType -> order
    const orderMap = new Map<string, number>();
    this.jobApplicationListValues.forEach((item: any) => {
      if (item.itemId && item.order !== undefined && item.order !== null) {
        orderMap.set(item.itemId, item.order);
      }
    });

    console.log('📊 Order map:', orderMap);

    // Sort events by order (events without order go to the end)
    const orderedEvents = [...events].sort((a, b) => {
      const orderA = orderMap.get(a.activityType) ?? 9999;
      const orderB = orderMap.get(b.activityType) ?? 9999;

      // If same order, sort by date (earliest first)
      if (orderA === orderB) {
        return new Date(a.createdOn).getTime() - new Date(b.createdOn).getTime();
      }

      return orderA - orderB;
    });

    return orderedEvents;
  }

  // STEP 2: Group events into stages (Applied, Shortlisted, Interview, Selected, Offered, Onboarded)
  groupEventsIntoStages(orderedEvents: any[]): any {
    const stageMapping = {
      'APPLIED': {
        id: 'APPLIED',
        label: 'Applied',
        activityTypes: ['JOB-APPLIED', 'APPLIED']
      },
      'SHORTLISTED': {
        id: 'SHORTLISTED',
        label: 'Shortlisted',
        activityTypes: ['CANDIDATE-SHORTLISTED', 'SHORTLISTED']
      },
      'INTERVIEW': {
        id: 'INTERVIEW',
        label: 'Interview',
        activityTypes: ['INTERVIEW-SCHEDULED', 'INTERVIEW-ACCEPTED', 'INTERVIEW-REJECTED', 'INTERVIEW SCHEDULED', 'L1-INTERVIEW', 'L2-INTERVIEW', 'L3-INTERVIEW']
      },
      'SELECTED': {
        id: 'SELECTED',
        label: 'Selected',
        activityTypes: ['CANDIDATE-SELECTED', 'SELECTED']
      },
      'OFFERED': {
        id: 'OFFERED',
        label: 'Offered',
        activityTypes: ['OFFERED', 'OFFER-ACCEPTED', 'OFFER-DECLINED', 'OFFER-WITHDRAWN']
      },
      'ONBOARDED': {
        id: 'ONBOARDED',
        label: 'Onboarded',
        activityTypes: ['ONBOARDED', 'PREONBOARDED', 'PRE-ONBOARDED']
      }
    };

    // Build reverse lookup: activityType -> stageId
    const activityToStage = new Map<string, string>();
    Object.entries(stageMapping).forEach(([stageId, config]: any) => {
      config.activityTypes.forEach((activityType: string) => {
        activityToStage.set(activityType, stageId);
      });
    });

    // Group events by stage
    const grouped: any = {
      APPLIED: { events: [], hasRejection: false, latestEvent: null },
      SHORTLISTED: { events: [], hasRejection: false, latestEvent: null },
      INTERVIEW: { events: [], hasRejection: false, latestEvent: null },
      SELECTED: { events: [], hasRejection: false, latestEvent: null },
      OFFERED: { events: [], hasRejection: false, latestEvent: null },
      ONBOARDED: { events: [], hasRejection: false, latestEvent: null }
    };

    orderedEvents.forEach((event: any) => {
      const stageId = activityToStage.get(event.activityType);

      if (stageId && grouped[stageId]) {
        grouped[stageId].events.push(event);

        // Check if this is a rejection event
        const isRejection = this.isNegativeStatus(event.activityType);
        if (isRejection) {
          grouped[stageId].hasRejection = true;
          console.log(`🚨 Rejection detected: ${event.activityType} in stage ${stageId}`);
        }

        // Track the latest event (most recent by order/date)
        if (!grouped[stageId].latestEvent) {
          grouped[stageId].latestEvent = event;
        } else {
          // Compare by date if same stage has multiple events
          const currentDate = new Date(event.createdOn).getTime();
          const latestDate = new Date(grouped[stageId].latestEvent.createdOn).getTime();
          if (currentDate > latestDate) {
            grouped[stageId].latestEvent = event;
          }
        }

        console.log(`  ✓ Event ${event.activityType} → ${stageId} (rejection: ${isRejection})`);
      } else {
        console.warn('⚠️ Unknown activity type:', event.activityType);
      }
    });

    return grouped;
  }

  // STEP 3: Build timeline stages from grouped events with rejection handling
  buildTimelineStagesFromGroupedEvents(groupedStages: any): any[] {
    const stageOrder = ['APPLIED', 'SHORTLISTED', 'INTERVIEW', 'SELECTED', 'OFFERED', 'ONBOARDED'];
    const stages: any[] = [];

    let rejectionFound = false;
    let hasAnyRejection = false;

    // First pass: Check if there's ANY rejection in the timeline
    for (let i = 0; i < stageOrder.length; i++) {
      const stageData = groupedStages[stageOrder[i]];
      if (stageData.hasRejection) {
        hasAnyRejection = true;
        break;
      }
    }

    console.log(`🔍 Has any rejection in timeline: ${hasAnyRejection}`);

    // Build stages in order
    for (let i = 0; i < stageOrder.length; i++) {
      const stageId = stageOrder[i];
      const stageData = groupedStages[stageId];

      // If rejection already found, STOP - don't add any more stages
      if (rejectionFound) {
        console.log(`🛑 Skipping stage ${stageId} - rejection already found, timeline ends`);
        break;
      }

      // Determine label
      const labelMap: any = {
        'APPLIED': 'Applied',
        'SHORTLISTED': 'Shortlisted',
        'INTERVIEW': 'Interview',
        'SELECTED': 'Selected',
        'OFFERED': 'Offered',
        'ONBOARDED': 'Onboarded'
      };

      const hasEvents = stageData.events.length > 0;
      const latestEvent = stageData.latestEvent;
      const baseLabel = labelMap[stageId] || stageId;

      // LOGIC: If rejection exists anywhere, skip empty stages
      //        If no rejection exists, show ALL stages (completed + future)
      if (!hasEvents && hasAnyRejection) {
        console.log(`⏭️ Skipping empty stage ${stageId} (rejection exists in timeline)`);
        continue;
      }

      // Determine if this is a rejection
      const isNegative = latestEvent ? this.isNegativeStatus(latestEvent.activityType) : false;

      // For rejected events, show the specific rejection name
      // For normal events, use the stage label
      let displayLabel = baseLabel;
      if (isNegative && latestEvent) {
        const eventName = this.getTimelineFilterValue(latestEvent.activityType);
        displayLabel = eventName || latestEvent.activityType || baseLabel;
      }

      console.log(`✅ Stage ${stageId}: hasEvents=${hasEvents}, isNegative=${isNegative}, displayLabel=${displayLabel}`);

      // Create stage object
      const stage: any = {
        id: stageId,
        label: displayLabel,
        baseLabel: baseLabel,
        date: latestEvent ? new Date(latestEvent.createdOn) : null,
        completed: hasEvents,
        active: false,
        notion: hasEvents ? 'default' : 'future',
        isNegative: isNegative,
        isTerminal: false,
        activityType: latestEvent?.activityType,
        events: stageData.events
      };

      // Determine notion based on latest event (for completed stages)
      if (latestEvent) {
        stage.notion = this.determineNotion(latestEvent.activityType);
      }

      // If this stage has a rejection, mark it as terminal and STOP
      if (isNegative) {
        rejectionFound = true;
        stage.isTerminal = true;
        stage.active = true;
        console.log(`🛑 REJECTION at stage: ${stageId} (${displayLabel}) - STOPPING HERE`);
        stages.push(stage);
        break;
      }

      // Add stage to timeline
      stages.push(stage);
    }

    // NEW LOGIC: Fill in skipped stages up to highest completed
    let highestCompletedIndex = -1;

    // Find the highest completed stage (with actual events)
    for (let i = stages.length - 1; i >= 0; i--) {
      if (stages[i].completed && !stages[i].isNegative && !rejectionFound) {
        highestCompletedIndex = i;
        break;
      }
    }

    console.log(`🔍 Highest completed stage index: ${highestCompletedIndex}`);

    // Mark all stages up to the highest as completed (fill in gaps for skipped stages)
    if (highestCompletedIndex >= 0 && !rejectionFound) {
      for (let i = 0; i <= highestCompletedIndex; i++) {
        if (!stages[i].isNegative) {
          // Store whether this was an actual event or implied
          const wasActuallyCompleted = stages[i].completed;

          stages[i].completed = true;
          stages[i].notion = 'default';

          // Mark as implied if it didn't have actual events (skipped stage)
          if (!wasActuallyCompleted) {
            stages[i].isImplied = true;

            // Find the next actually completed stage and copy its date
            let nextActualDate = null;
            for (let j = i + 1; j <= highestCompletedIndex; j++) {
              if (!stages[j].isImplied && stages[j].date) {
                nextActualDate = stages[j].date;
                break;
              }
            }

            // Set the date to the next actual completion date
            if (nextActualDate) {
              stages[i].date = nextActualDate;
              console.log(`✨ Stage ${stages[i].id} marked as implied completion (skipped) with date from next actual stage`);
            } else {
              console.log(`✨ Stage ${stages[i].id} marked as implied completion (skipped) - no date available`);
            }
          }
        }
      }

      // Mark the highest completed stage as active
      stages[highestCompletedIndex].active = true;
      console.log(`✅ Stage ${stages[highestCompletedIndex].id} marked as active (highest)`);
    }

    // If rejection found, it's already marked as active in the rejection logic above
    if (rejectionFound) {
      console.log(`🛑 Rejection found - timeline ends at rejection point`);
    }

    console.log('🎯 Final timeline:', stages.map(s => `${s.id}(${s.label}, completed:${s.completed}, implied:${s.isImplied || false}, negative:${s.isNegative})`));
    return stages;
  }

  // Get default timeline stages when no events exist
  getDefaultTimelineStages() {
    return [
      { id: 'APPLIED', label: 'Applied', date: null, completed: false, active: false, notion: 'default', isNegative: false, isTerminal: false },
      { id: 'SHORTLISTED', label: 'Shortlisted', date: null, completed: false, active: false, notion: 'progress', isNegative: false, isTerminal: false },
      { id: 'INTERVIEW', label: 'Interview', date: null, completed: false, active: false, notion: 'progress', isNegative: false, isTerminal: false },
      { id: 'SELECTED', label: 'Selected', date: null, completed: false, active: false, notion: 'positive', isNegative: false, isTerminal: false },
      { id: 'OFFERED', label: 'Offered', date: null, completed: false, active: false, notion: 'positive', isNegative: false, isTerminal: false },
      { id: 'ONBOARDED', label: 'Onboarded', date: null, completed: false, active: false, notion: 'positive', isNegative: false, isTerminal: false }
    ];
  }

  // Determine notion based on activity type
  determineNotion(activityType: string): string {
    const negativeStatuses = [
      'REJECTED',
      'INTERVIEW-REJECTED',
      'OFFER-DECLINED',
      'OFFER-WITHDRAWN',
      'CANDIDATE-REJECTED',
      'APPLICATION-REJECTED'
    ];
    const progressStatuses = [
      'CANDIDATE-SHORTLISTED',
      'SHORTLISTED',
      'INTERVIEW-SCHEDULED',
      'INTERVIEW-ACCEPTED',
      'INTERVIEW SCHEDULED'
    ];
    const positiveStatuses = [
      'CANDIDATE-SELECTED',
      'SELECTED',
      'OFFERED',
      'OFFER-ACCEPTED',
      'ONBOARDED',
      'PREONBOARDED',
      'PRE-ONBOARDED'
    ];

    if (negativeStatuses.some(neg => activityType.includes(neg) || neg.includes(activityType))) return 'negative';
    if (progressStatuses.includes(activityType)) return 'progress';
    if (positiveStatuses.includes(activityType)) return 'positive';
    return 'default';
  }

  // Check if status is negative (rejection)
  isNegativeStatus(activityType: string): boolean {
    const negativeKeywords = [
      'REJECTED',
      'REJECT',
      'DECLINED',
      'DECLINE',
      'WITHDRAWN',
      'WITHDRAW'
    ];

    // Check if activityType contains any negative keyword
    return negativeKeywords.some(keyword =>
      activityType.toUpperCase().includes(keyword)
    );
  }


  getAllSkills(candidateval: any): string[] {
    const primary = candidateval?.primarySkills || [];
    const secondary = candidateval?.secondarySkills || [];
    return [...primary, ...secondary]; // merge both arrays
  }

  openCandidateInSlidePanel(candidateData: any): void {
    if (this.viewSize === 'contract-row-v3') {
      // Contract-row-v3 uses a transformed/simplified candidate object.
      // Fetch full candidate details from API before opening the slide panel.
      const candidateId = candidateData?.candidateId;
      const jobId = candidateData?.contractData?.jobId || this.currentJobId;
      if (!candidateId) return;
      this.util.startLoader();
      this.apiService.query('candidates/findCandidateById/' + candidateId).subscribe(
        (res: any) => {
          this.util.stopLoader();
          if (res?.code === '00000' && res?.data?.candidateData) {
            const fullCandidate = res.data.candidateData;
            // Open the V3 profile slider (same as Job Applicants); no opts = legacy v2.
            this.slidePanelService.openCandidateDetail(fullCandidate, jobId, {
              variant: 'v3',
              initialTab: 'profile',
              pageFrom: 'contract-candidates',
              jobData: this.jobDetails || this.appliedJobDetails,
              hideAiInsights: true               // no AI % / AI Insights tab here (2026-09-08)
            });
          }
        },
        () => {
          this.util.stopLoader();
        }
      );
    } else if (this.useV3Slider) {
      this.slidePanelService.openCandidateDetail(candidateData, this.currentJobId, {
        variant: 'v3',
        initialTab: 'profile',
        hideAiInsights: this.hideAiInsights,
        // Job context (when this card sits under a job) so the slider's Pay
        // Rate shows the job's range. Undefined on candidate-centric views
        // (talent pool/center) → slider falls back to the candidate range.
        jobData: this.jobDetails || this.appliedJobDetails,
        // Single-scroll drawer only on the SuperAdmin org pages (Job
        // Center / Talent Center / Talent Pool use viewSize
        // 'customer-row-design'). Leaves dashboards / applicants table
        // on the original whole-panel scroll.
        compactScroll: this.viewSize === 'customer-row-design',
        // Tag the org candidate view so the slider can scope features:
        //   'talent-center' → Talent Center (own-candidate "You" + hide
        //                      Connect/personal-chat, AND chat-after-connect)
        //   'talent-pool'   → Talent Pool (chat-after-connect only)
        // Both gate the rec-strip chat on an established connection; the
        // own-candidate "You"/hide-connect tweak stays Talent-Center-only
        // (its getter checks pageFrom === 'talent-center' specifically).
        pageFrom: this.viewSize === 'customer-row-design'
          ? (this.isTalentPool ? 'talent-pool' : 'talent-center')
          : undefined
      });
    } else {
      this.slidePanelService.openCandidateDetail(candidateData, this.currentJobId);
    }
  }

  async fetchAndDownloadResume(candidateData: any) {
    const candidateId = candidateData?.candidateId;
    if (!candidateId) return;

    // Run plan check first (while still in user-gesture context)
    try {
      const userData = await this.planService.UPDATE_USERDETAILS("ACTIVE_INTERACTIONS");
      if (userData.isExpired) {
        const membershipType = userData.membershipType;
        let availablePoints = null, actualPoints = null, utilizedPoints = null, promotional = null;
        userData.userDetail?.userPlanAndBenefits?.benefitsUsages?.forEach(ele => {
          if (ele.benefitKey == 'ACTIVE_INTERACTIONS') {
            availablePoints = ele.available; actualPoints = ele.actual;
            utilizedPoints = ele.utilized; promotional = ele.promotional;
          }
        });
        let popupType: "PAY" | "LIMIT" | "UPGRADE" = ['Starter', 'Growth', 'ScaleX'].includes(membershipType) ? "LIMIT" : "PAY";
        this.planService.expiredPopup("ACTIVE_INTERACTIONS", popupType, null, null, null, null, availablePoints, actualPoints, utilizedPoints, promotional);
        return;
      }
    } catch { return; }

    // Fetch full candidate data to get resumes
    this.util.startLoader();
    this.apiService.query('candidates/findCandidateById/' + candidateId).subscribe(
      (res: any) => {
        this.util.stopLoader();
        if (res?.code === '00000' && res?.data?.candidateData) {
          const full = res.data.candidateData;
          // Cache on the local object so subsequent clicks don't re-fetch
          candidateData.resumes = full.resumes || [];
          candidateData.resumeAttached = full.resumeAttached;
          candidateData.createdBy = candidateData.createdBy || full.createdBy;
          const defaultResume = full.resumes?.find((r: any) => r.isDefault);
          const fileId = defaultResume?.fileId || full.resumes?.[0]?.fileId;
          // Strip the backend's `<uuid>_` disk-name prefix (parity with the
          // regular downloadResume() path) so the saved file keeps the real
          // resume name instead of the raw S3 reference id. `candidateData.resumes`
          // was just cached above, so resolveResumeFileName can match by fileId.
          const fileName = this.resolveResumeFileName(candidateData, fileId)
            || defaultResume?.fileName || full.resumes?.[0]?.fileName;
          if (fileId) {
            this.afterPlanValidationDownloadResume(full.candidateId, this.userId, full.createdBy, fileId, fileName);
          } else {
            Swal.fire({ icon: 'info', title: 'No resume available for this candidate.', timer: 2000, showConfirmButton: false });
          }
        }
      },
      () => { this.util.stopLoader(); }
    );
  }

  getBorderRadius(value: string): string {
    return value?.length < 50 ? '999px' : '20px';
  }

  /**
   * Dynamically loads NewJobComponent to break circular dependency
   * Called when job listing modal needs to be displayed
   */
  async loadNewJobComponent(retryCount: number = 0) {
    const maxRetries = 5;

    // If container hasn't been found yet, try to get it from the modal's DOM
    if (!this.newJobContainer) {
      if (retryCount < maxRetries) {
        // Try to find the container element in the modal's DOM
        const containerElement = document.getElementById('newJobDynamicContainerCandidateCard');

        if (!containerElement) {
          const delay = 50 * Math.pow(2, retryCount); // 50ms, 100ms, 200ms, 400ms, 800ms
          console.log(`[CandidateCard] NewJobContainer not ready, retrying in ${delay}ms (attempt ${retryCount + 1}/${maxRetries})`);
          setTimeout(() => this.loadNewJobComponent(retryCount + 1), delay);
          return;
        }
      } else {
        console.error('[CandidateCard] NewJobContainer not available after maximum retries');
        return;
      }
    }

    console.log('[CandidateCard] Proceeding with dynamic component load...');

    try {
      console.log('[CandidateCard] Loading NewJobComponent dynamically...');

      // Dynamic import to break circular dependency
      const { NewJobComponent } = await import('../../../page/homepage/layout-jobs/new-job/new-job.component');

      // Get the container element
      const containerElement = document.getElementById('newJobDynamicContainerCandidateCard');

      if (containerElement) {
        // Clear previous content
        containerElement.innerHTML = '';

        // Use ApplicationRef to create and attach the component
        const componentFactory = this.injector.get(ComponentFactoryResolver);
        const factory = componentFactory.resolveComponentFactory(NewJobComponent);

        // Create the component
        this.newJobComponentRef = factory.create(this.injector);

        // Set inputs (maintaining all @Input decorators)
        this.newJobComponentRef.instance.focus = this.focus;
        this.newJobComponentRef.instance.screenName = 'invite-job-listing';
        this.newJobComponentRef.instance.filterData = this.candidateData;

        // Attach the component's host view to the application
        const appRef = this.injector.get(ApplicationRef);
        appRef.attachView(this.newJobComponentRef.hostView);

        // Append the component's DOM element to our container
        const domElem = (this.newJobComponentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
        containerElement.appendChild(domElem);

        // Trigger change detection
        this.newJobComponentRef.changeDetectorRef.detectChanges();

        console.log('[CandidateCard] NewJobComponent loaded successfully');
      } else {
        console.error('[CandidateCard] Container element not found in DOM');
      }
    } catch (error) {
      console.error('[CandidateCard] Error loading NewJobComponent:', error);
    }
  }

  ngOnDestroy(): void {
    // Clean up dynamically loaded component
    if (this.newJobComponentRef) {
      const appRef = this.injector.get(ApplicationRef);
      appRef.detachView(this.newJobComponentRef.hostView);
      this.newJobComponentRef.destroy();
      this.newJobComponentRef = null;
    }
  }

  timelineDataGrouped:any;
  positiveStages = ['JOB-APPLIED','CANDIDATE-SHORTLISTED','INTERVIEW-SCHEDULED','INTERVIEW-ACCEPTED','CANDIDATE-SELECTED','OFFERED','OFFER-ACCEPTED','PRE-ONBOARDED','ONBOARDED'];
  negativeStages = ['REJECTED','PROFILE-REJECTED','INTERVIEW-REJECTED','INTERVIEW-FAILED','OFFER-DECLINED','CANDIDATE-WITHDRAWN','OFFER-WITHDRAWN'];
  timelineStatusLabelMap: Record<string, string> = {
    'REJECTED': 'Rejected',
    'PROFILE-REJECTED': 'Profile Rejected',
    'INTERVIEW-REJECTED': 'Interview Rejected',
    'INTERVIEW-FAILED': 'Interview Failed',
    'OFFER-DECLINED': 'Offer Declined',
    'CANDIDATE-WITHDRAWN': 'Candidate Withdrawn',
    'OFFER-WITHDRAWN': 'Offer Withdrawn'
  };

  isTimelineLoading = false;
  defaultTimelineSkeleton = this.getDefaultTimelineStagesEnhanced(); // reuse your existing method

  async prepareTimeline(){
    console.log('NewTimelineLoaded.')
    const payload = {
      entityId: this.currentJobId,
      entityType: "JOB",
      limit: 20,
      searchAfterKey: null,
      activityOn: this.candidateval.candidateId,
      parentActivity: "JOB_APPLICATION,CANDIDATE_INVITATION",
      owner: this.appliedJobDetails?.jobPostedBy === localStorage.getItem('userId')
    };
    this.isTimelineLoading = true;
    this.apiService.create("jobs/findTimeLines", payload).subscribe(res => {
      console.log('Timeline API response:', res);
      if (res && res.code === "00000" && res.data) {
        let timelines = res.data?.timeLines || [];
        if (timelines.length > 0) {
          timelines = timelines.reverse();
          let defaultTimeline = this.getDefaultTimelineStagesEnhanced();
          let lastCompletedIndex = 0;

          for (let i = 0; i < timelines.length; i++) {
            let t = timelines[i];

            // 🔴 NEGATIVE STATUS
            if (this.negativeStages.includes(t.activityType)) {
              let targetIndex = Math.min(lastCompletedIndex + 1, defaultTimeline.length - 1);
              let stag = defaultTimeline[targetIndex];
              stag.negative = true;
              stag.future = false;
              stag.completed = true;
              stag.label = this.timelineStatusLabelMap[t.activityType];
              stag.date = t.createdOn;
              break;
            }

            // ✅ POSITIVE / NORMAL STATUS
            let stage = defaultTimeline.find(d => d.relatedStatuses.includes(t.activityType));
            if (!stage) continue;

            stage.completed = true;
            stage.future = false;
              stage.date = t.createdOn;
            stage.negative = false; 
            lastCompletedIndex = stage.index;
            
            // 👉 IMPLIED PRIOR STAGES
            for (let j = 0; j < stage.index; j++) {
              let isNotCompletedStage = defaultTimeline[j]; 
              if (isNotCompletedStage && !isNotCompletedStage.completed) {
                isNotCompletedStage.completed = true;
                isNotCompletedStage.future = false;
                isNotCompletedStage.date = t.createdOn;
                isNotCompletedStage.negative = false; 
                isNotCompletedStage.isImplied = true;
              }
            }
          }
          this.isTimelineLoading = false;
          this.timelineDataGrouped = defaultTimeline;
        }
      }
    }, err => {
      console.error('Timeline API error:', err);
    });
  }

  getDefaultTimelineStagesEnhanced() {
    return [
      { index: 0, id: 'APPLIED',     label: 'Applied',     date: null, completed: false, negative: false, future: true, isImplied: false, relatedStatuses: ['JOB-APPLIED'] },
      { index: 1, id: 'SHORTLISTED', label: 'Shortlisted', date: null, completed: false, negative: false, future: true, isImplied: false, relatedStatuses: ['CANDIDATE-SHORTLISTED'] },
      { index: 2, id: 'INTERVIEW',   label: 'Interview',   date: null, completed: false, negative: false, future: true, isImplied: false, relatedStatuses: ['INTERVIEW-SCHEDULED', 'INTERVIEW-ACCEPTED', 'L1-INTERVIEW', 'L2-INTERVIEW', 'L3-INTERVIEW'] },
      { index: 3, id: 'SELECTED',    label: 'Selected',    date: null, completed: false, negative: false, future: true, isImplied: false, relatedStatuses: ['CANDIDATE-SELECTED'] },
      { index: 4, id: 'OFFERED',     label: 'Offered',     date: null, completed: false, negative: false, future: true, isImplied: false, relatedStatuses: ['OFFERED', 'OFFER-ACCEPTED'] },
      { index: 5, id: 'ONBOARDED',   label: 'Onboarded',   date: null, completed: false, negative: false, future: true, isImplied: false, relatedStatuses: ['ONBOARDED'] }
    ];
  }
}